// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vibe-block-design-wizard-card {
  width: 100%;
  max-width: 550px;
  margin: 14px 0 4px;
  padding: 16px;
  border: 1px solid #cbdcff;
  border-radius: 20px;
  background: linear-gradient(145deg, #f8fbff 0%, #f4f7ff 55%, #f9f5ff 100%);
  box-shadow: 0 10px 30px rgba(34, 77, 163, 0.09);
}

.vibe-block-design-wizard-card__header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.vibe-block-design-wizard-card--answered {
  padding: 13px 15px;
  background: linear-gradient(145deg, #f8fbff 0%, #f2fbf6 100%);
}

.vibe-block-design-wizard-card__header--answered {
  align-items: flex-start;
  margin-bottom: 9px;
}

.vibe-block-design-wizard-card__answered-check {
  display: grid;
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 50%;
  background: #dff4e7;
  color: #287447;
  font-size: 13px;
  font-weight: 800;
}

.vibe-block-design-wizard-card__eyebrow {
  margin-bottom: 5px;
  color: #4267b1;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.vibe-block-design-wizard-card__question {
  margin: 0;
  color: #1f2e49;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.35;
}

.vibe-block-design-wizard-card__helper {
  margin: 6px 0 0;
  color: #66738b;
  font-size: 13px;
  line-height: 1.45;
}

.vibe-block-design-wizard-card__step-dots {
  display: flex;
  flex: 0 0 auto;
  gap: 5px;
  padding-top: 5px;
}

.vibe-block-design-wizard-card__step-dots span {
  width: 18px;
  height: 5px;
  border-radius: 999px;
  background: #dce5f7;
}

.vibe-block-design-wizard-card__step-dots span.is-active {
  background: #4b7cff;
}

.vibe-block-design-wizard-options {
  display: grid;
  gap: 9px;
}

.vibe-block-design-wizard-option {
  position: relative;
  display: grid;
  grid-template-columns: 118px 1fr;
  align-items: center;
  width: 100%;
  min-height: 98px;
  padding: 9px 34px 9px 9px;
  overflow: hidden;
  border: 1px solid #dbe4f7;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.88);
  color: inherit;
  text-align: left;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.vibe-block-design-wizard-option:not(:disabled):hover {
  border-color: #92afff;
  box-shadow: 0 7px 18px rgba(53, 93, 176, 0.11);
  transform: translateY(-1px);
}

.vibe-block-design-wizard-option.is-selected {
  border-color: #4b7cff;
  box-shadow: 0 0 0 2px rgba(75, 124, 255, 0.13);
}

.vibe-block-design-wizard-option:disabled {
  cursor: default;
}

.vibe-block-design-wizard-option__copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding-left: 12px;
}

.vibe-block-design-wizard-option__title {
  color: #263654;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
}

.vibe-block-design-wizard-option__title span:not(.vibe-block-design-wizard-option__badge-recommended):not(.vibe-block-design-wizard-option__badge-star),
.vibe-block-design-wizard-option__explanation {
  color: #596983;
  font-weight: 500;
}

.vibe-block-design-wizard-option__title .vibe-block-design-wizard-option__badge-recommended {
  display: inline-flex;
  align-items: center;
  gap: 3.5px;
  padding: 1.5px 7px;
  margin-left: 6px;
  margin-right: 3px;
  border-radius: 9999px;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  color: #3730a3;
  font-size: 10.5px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0.01em;
  vertical-align: middle;
  white-space: nowrap;
}

.vibe-block-design-wizard-option__badge-star {
  color: #6366f1;
  font-size: 9.5px;
  line-height: 1;
}

.vibe-block-design-wizard-option.is-selected .vibe-block-design-wizard-option__badge-recommended {
  background: #e0e7ff;
  border-color: #a5b4fc;
  color: #312e81;
}

.vibe-block-design-wizard-option.is-selected .vibe-block-design-wizard-option__badge-star {
  color: #4338ca;
}

.vibe-block-design-wizard-option__effect {
  margin-top: 5px;
  color: #46705a;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.35;
}

.vibe-block-design-wizard-option__check {
  position: absolute;
  top: 10px;
  right: 10px;
  display: grid;
  width: 18px;
  height: 18px;
  place-items: center;
  border: 1px solid #ccd8ef;
  border-radius: 50%;
  background: #fff;
  color: transparent;
  font-size: 11px;
}

.vibe-block-design-wizard-option.is-selected .vibe-block-design-wizard-option__check {
  border-color: #4b7cff;
  background: #4b7cff;
  color: #fff;
}

.vibe-block-design-wizard-preview-shell {
  min-width: 0;
}

.vibe-block-design-wizard-preview {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 118px;
  height: 69px;
  padding: 0;
  overflow: hidden;
  border-radius: 11px;
  background: linear-gradient(145deg, #e8efff, #f5eaff);
  isolation: isolate;
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.vibe-block-design-wizard-option-art {
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.vibe-block-design-wizard-option-art-custom {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.vibe-block-design-wizard-option-art-custom svg {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 118px;
  max-height: 69px;
  -o-object-fit: contain;
     object-fit: contain;
}

/* Dynamic motif palettes */
.vibe-block-design-wizard-preview--motif-character {
  background: radial-gradient(circle at 50% 30%, #2e266d 0%, #17133d 65%, #0c0a21 100%);
  border: 1px solid rgba(165, 180, 252, 0.3);
  box-shadow: inset 0 0 16px rgba(129, 140, 248, 0.25);
}

.vibe-block-design-wizard-preview--motif-scene {
  background: radial-gradient(circle at 60% 30%, #1e293b 0%, #0f172a 70%, #020617 100%);
  border: 1px solid rgba(56, 189, 248, 0.3);
  box-shadow: inset 0 0 16px rgba(56, 189, 248, 0.22);
}

.vibe-block-design-wizard-preview--motif-particles {
  background: radial-gradient(circle at 50% 50%, #1a103c 0%, #090d16 70%, #020617 100%);
  border: 1px solid rgba(45, 212, 191, 0.3);
  box-shadow: inset 0 0 16px rgba(45, 212, 191, 0.22);
}

.vibe-block-design-wizard-preview--motif-cards {
  background: radial-gradient(circle at 50% 30%, #1e293b 0%, #0f172a 100%);
  border: 1px solid rgba(99, 102, 241, 0.25);
  box-shadow: inset 0 0 14px rgba(99, 102, 241, 0.18);
}

.vibe-block-design-wizard-preview--motif-gallery {
  background: radial-gradient(circle at 50% 40%, #172554 0%, #0c1a30 100%);
  border: 1px solid rgba(56, 189, 248, 0.25);
  box-shadow: inset 0 0 14px rgba(56, 189, 248, 0.18);
}

.vibe-block-design-wizard-preview--motif-product {
  background: radial-gradient(circle at 50% 25%, #27272a 0%, #18181b 70%, #09090b 100%);
  border: 1px solid rgba(251, 191, 36, 0.3);
  box-shadow: inset 0 0 14px rgba(251, 191, 36, 0.22);
}

.vibe-block-design-wizard-preview--motif-timeline {
  background: radial-gradient(circle at 50% 30%, #1e1b4b 0%, #0f172a 100%);
  border: 1px solid rgba(59, 130, 246, 0.3);
  box-shadow: inset 0 0 14px rgba(59, 130, 246, 0.22);
}

.vibe-block-design-wizard-preview--motif-cta,
.vibe-block-design-wizard-preview--motif-content,
.vibe-block-design-wizard-preview--motif-abstract {
  background: radial-gradient(circle at 70% 30%, #eef2ff 0%, #e0e7ff 55%, #f1f5f9 100%);
  border: 1px solid rgba(99, 102, 241, 0.2);
  box-shadow: inset 0 0 12px rgba(99, 102, 241, 0.12);
}

/* Micro-Animations for Artwork */
@keyframes vibeMascotFloat {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-3.2px) rotate(0.8deg); }
}

/* 1. Pirouette & Jump (360deg rotation + mid-air jump + bounce) */
@keyframes vibeMascotSpinJump {
  0%, 100% {
    transform: translateY(0) rotate(0deg) scale(1, 1);
  }
  15% {
    transform: translateY(2.5px) rotate(0deg) scale(1.1, 0.9);
  }
  42% {
    transform: translateY(-13px) rotate(180deg) scale(0.95, 1.05);
  }
  65% {
    transform: translateY(-4px) rotate(360deg) scale(0.98, 1.02);
  }
  78% {
    transform: translateY(2px) rotate(360deg) scale(1.08, 0.92);
  }
  90% {
    transform: translateY(0) rotate(360deg) scale(1, 1);
  }
}

/* 2. Hop / Jump straight up (0deg rotation, clean spring and landing) */
@keyframes vibeMascotHop {
  0%, 100% {
    transform: translateY(0) scale(1, 1);
  }
  15% {
    transform: translateY(2.5px) scale(1.12, 0.88);
  }
  45% {
    transform: translateY(-13px) scale(0.92, 1.1);
  }
  75% {
    transform: translateY(1.5px) scale(1.08, 0.92);
  }
  88% {
    transform: translateY(0) scale(1, 1);
  }
}

/* 3. Double Spin + Sparkle Burst (720deg rapid pirouette + peak flash) */
@keyframes vibeMascotDoubleSpin {
  0%, 100% {
    transform: translateY(0) rotate(0deg) scale(1, 1);
  }
  12% {
    transform: translateY(3px) rotate(0deg) scale(1.12, 0.88);
  }
  38% {
    transform: translateY(-14px) rotate(360deg) scale(0.94, 1.06);
  }
  62% {
    transform: translateY(-16px) rotate(720deg) scale(0.95, 1.05);
  }
  80% {
    transform: translateY(2px) rotate(720deg) scale(1.1, 0.9);
  }
  92% {
    transform: translateY(0) rotate(720deg) scale(1, 1);
  }
}

@keyframes vibeSparkleBurst {
  0%, 30% {
    opacity: 0;
    transform: scale(0.2) rotate(0deg);
  }
  50%, 65% {
    opacity: 1;
    transform: scale(1.25) rotate(45deg);
    filter: drop-shadow(0 0 8px rgba(254, 240, 138, 0.95));
  }
  82%, 100% {
    opacity: 0;
    transform: scale(1.6) rotate(90deg);
  }
}

/* 4. Tilt / Curious sway */
@keyframes vibeMascotTilt {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-2px) rotate(-6deg); }
  75% { transform: translateY(-2px) rotate(6deg); }
}

.vibe-block-art-mascot--spin-jump {
  animation: vibeMascotSpinJump 2.4s cubic-bezier(0.34, 1.3, 0.64, 1) infinite;
  transform-origin: 59px 38px;
}

.vibe-block-art-mascot--hop {
  animation: vibeMascotHop 2.0s cubic-bezier(0.25, 1, 0.5, 1) infinite;
  transform-origin: 59px 48px;
}

.vibe-block-art-mascot--spin-burst {
  animation: vibeMascotDoubleSpin 2.6s cubic-bezier(0.34, 1.25, 0.64, 1) infinite;
  transform-origin: 59px 38px;
}

.vibe-block-art-sparkle-burst {
  animation: vibeSparkleBurst 2.6s cubic-bezier(0.16, 1, 0.3, 1) infinite;
  transform-origin: 59px 36px;
}

.vibe-block-art-mascot--tilt {
  animation: vibeMascotTilt 2.5s ease-in-out infinite;
  transform-origin: 59px 44px;
}

.vibe-block-art-mascot--aura {
  animation: vibeMascotAura 3.0s ease-in-out infinite;
  transform-origin: 59px 38px;
}

.vibe-block-art-aura-rings {
  animation: vibeAuraPulse 3.0s ease-in-out infinite;
  transform-origin: 58px 38px;
}

.vibe-block-art-mascot--cursor-hover {
  animation: vibeMascotCursorReaction 2.6s ease-in-out infinite;
  transform-origin: 59px 44px;
}

.vibe-block-art-cursor-pointer {
  animation: vibeCursorFloat 2.6s ease-in-out infinite;
  transform-origin: 75px 38px;
}

.vibe-block-art-mascot--tap-ripple {
  animation: vibeMascotTap 2.2s cubic-bezier(0.34, 1.3, 0.64, 1) infinite;
  transform-origin: 59px 44px;
}

.vibe-block-art-tap-ripple-group {
  animation: vibeTapWave 2.2s cubic-bezier(0.16, 1, 0.3, 1) infinite;
  transform-origin: 58px 40px;
}

.vibe-block-art-mascot--speed-dash {
  animation: vibeMascotDash 2.0s cubic-bezier(0.25, 1, 0.5, 1) infinite;
  transform-origin: 59px 38px;
}

.vibe-block-art-speed-streaks {
  animation: vibeStreaksFlash 2.0s ease-in-out infinite;
  transform-origin: 20px 40px;
}

.vibe-block-art-mascot--float-smooth {
  animation: vibeMascotSmoothFloat 3.8s ease-in-out infinite;
  transform-origin: 59px 38px;
}

.vibe-block-art-mascot--scroll-reveal {
  animation: vibeMascotScrollReveal 2.8s ease-in-out infinite;
  transform-origin: 59px 40px;
}

.vibe-block-art-mascot--float,
.vibe-block-art-mascot {
  animation: vibeMascotFloat 3.2s ease-in-out infinite;
  transform-origin: 59px 38px;
}

@keyframes vibeMascotAura {
  0%, 100% { transform: translateY(0) scale(1); filter: drop-shadow(0 0 6px rgba(129, 140, 248, 0.5)); }
  50% { transform: translateY(-3px) scale(1.03); filter: drop-shadow(0 0 12px rgba(192, 132, 252, 0.8)); }
}

@keyframes vibeAuraPulse {
  0%, 100% { transform: scale(0.92); opacity: 0.5; }
  50% { transform: scale(1.1); opacity: 0.95; }
}

@keyframes vibeCursorFloat {
  0%, 100% { transform: translate(6px, -6px); opacity: 0.6; }
  45%, 55% { transform: translate(0, 0); opacity: 1; filter: drop-shadow(0 2px 4px rgba(79, 70, 229, 0.4)); }
}

@keyframes vibeMascotCursorReaction {
  0%, 40% { transform: translateY(0) rotate(0deg); }
  50%, 70% { transform: translateY(-4px) rotate(-5deg) scale(1.05); }
  85%, 100% { transform: translateY(0) rotate(0deg); }
}

@keyframes vibeMascotTap {
  0%, 30% { transform: scale(1); }
  35% { transform: scale(0.92, 1.08); }
  45% { transform: translateY(-5px) scale(1.06, 0.95); }
  65% { transform: translateY(0) scale(1); }
  100% { transform: scale(1); }
}

@keyframes vibeTapWave {
  0%, 30% { transform: scale(0.3); opacity: 0; }
  40% { opacity: 0.9; }
  75%, 100% { transform: scale(1.4); opacity: 0; }
}

@keyframes vibeMascotDash {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-4px) scale(0.95, 1.05); }
  40% { transform: translateX(8px) skewX(-8deg); }
  65% { transform: translateX(2px); }
  80% { transform: translateX(0); }
}

@keyframes vibeStreaksFlash {
  0%, 20% { opacity: 0; transform: scaleX(0.4); }
  35%, 55% { opacity: 1; transform: scaleX(1.2); }
  70%, 100% { opacity: 0; transform: scaleX(0.4); }
}

@keyframes vibeMascotSmoothFloat {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-4.5px) rotate(1.5deg); }
}

@keyframes vibeMascotScrollReveal {
  0%, 20% { transform: translateY(8px); opacity: 0.4; }
  50%, 80% { transform: translateY(-2px); opacity: 1; }
  100% { transform: translateY(8px); opacity: 0.4; }
}

.vibe-block-art-grid-item {
  animation: vibeGridStagger 2.4s ease-in-out infinite;
}
.vibe-block-art-grid-item--2 { animation-delay: 0.3s; }
.vibe-block-art-grid-item--3 { animation-delay: 0.6s; }
.vibe-block-art-grid-item--4 { animation-delay: 0.9s; }

@keyframes vibeGridStagger {
  0%, 100% { transform: scale(1); opacity: 0.85; }
  50% { transform: scale(1.05); opacity: 1; filter: drop-shadow(0 2px 5px rgba(99, 102, 241, 0.4)); }
}

.vibe-block-art-carousel-track {
  animation: vibeCarouselSlide 3.2s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}

@keyframes vibeCarouselSlide {
  0%, 25% { transform: translateX(0); }
  45%, 70% { transform: translateX(-24px); }
  85%, 100% { transform: translateX(0); }
}

.vibe-block-art-vortex {
  animation: vibeVortexRotate 6s linear infinite;
  transform-origin: 59px 34px;
}

@keyframes vibeVortexRotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.vibe-block-art-firefly {
  animation: vibeFireflyRise 3.0s ease-in-out infinite;
}
.vibe-block-art-firefly--2 { animation-delay: 0.8s; }
.vibe-block-art-firefly--3 { animation-delay: 1.5s; }

@keyframes vibeFireflyRise {
  0% { transform: translateY(10px); opacity: 0; }
  40%, 60% { opacity: 1; filter: drop-shadow(0 0 4px #67e8f9); }
  100% { transform: translateY(-16px); opacity: 0; }
}

@keyframes vibeStarTwinkle {
  0%, 100% { opacity: 0.95; transform: scale(1); }
  50% { opacity: 0.35; transform: scale(0.72); }
}

@keyframes vibeParallaxDrift {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-3.5px); }
}

@keyframes vibeParallaxBack {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-1.5px, 1px); }
}

@keyframes vibeParticlePulse {
  0%, 100% { transform: scale(1); opacity: 0.95; }
  50% { transform: scale(1.2); opacity: 0.7; }
}

@keyframes vibeCardFloat {
  0%, 100% { transform: translateY(0px) rotate(6deg); }
  50% { transform: translateY(-2.8px) rotate(5deg); }
}

@keyframes vibeProductHover {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-3px); }
}

@keyframes vibeCtaPulse {
  0%, 100% { transform: scale(1); filter: drop-shadow(0 2px 5px rgba(79, 70, 229, 0.35)); }
  50% { transform: scale(1.04); filter: drop-shadow(0 3px 8px rgba(79, 70, 229, 0.6)); }
}

.vibe-block-art-star--1 {
  animation: vibeStarTwinkle 2.4s ease-in-out infinite;
  transform-origin: 23.5px 23.5px;
}

.vibe-block-art-star--2 {
  animation: vibeStarTwinkle 2.8s ease-in-out 0.8s infinite;
  transform-origin: 93px 19px;
}

.vibe-block-art-parallax-fore {
  animation: vibeParallaxDrift 3.4s ease-in-out infinite;
}

.vibe-block-art-parallax-back {
  animation: vibeParallaxBack 4.5s ease-in-out infinite;
}

.vibe-block-art-node--1, .vibe-block-art-node--2, .vibe-block-art-node--4 {
  animation: vibeParticlePulse 2.6s ease-in-out infinite;
  transform-origin: center;
}

.vibe-block-art-node--3, .vibe-block-art-node--5 {
  animation: vibeParticlePulse 3.1s ease-in-out 0.9s infinite;
  transform-origin: center;
}

.vibe-block-art-card--front {
  animation: vibeCardFloat 3.6s ease-in-out infinite;
  transform-origin: 69px 36px;
}

.vibe-block-art-product-float {
  animation: vibeProductHover 2.8s ease-in-out infinite;
}

.vibe-block-art-cta-btn {
  animation: vibeCtaPulse 2.2s ease-in-out infinite;
  transform-origin: 40px 44px;
}

.vibe-block-design-wizard-preview::before {
  position: absolute;
  inset: -35% 35% 20% -20%;
  border-radius: 50%;
  background: rgba(78, 124, 255, 0.17);
  content: '';
  filter: blur(9px);
  z-index: -1;
}

.vibe-block-design-wizard-preview__item {
  display: block;
  min-width: 0;
  min-height: 0;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.93);
  box-shadow: 0 2px 7px rgba(50, 75, 130, 0.14);
}

.vibe-block-design-wizard-preview--accent-image .vibe-block-design-wizard-preview__item--1,
.vibe-block-design-wizard-preview--accent-motion .vibe-block-design-wizard-preview__item--2 {
  background: linear-gradient(135deg, #7397ff, #b98cff);
}

.vibe-block-design-wizard-preview--accent-content .vibe-block-design-wizard-preview__item--1,
.vibe-block-design-wizard-preview--accent-cta .vibe-block-design-wizard-preview__item--3,
.vibe-block-design-wizard-preview--accent-cta .vibe-block-design-wizard-preview__item--6 {
  background: #527cf0;
}

.vibe-block-design-wizard-preview--carousel {
  grid-template-columns: 13px 1fr 1fr 13px;
  gap: 5px;
  align-items: center;
}

.vibe-block-design-wizard-preview--carousel .vibe-block-design-wizard-preview__item {
  height: 47px;
}

.vibe-block-design-wizard-preview--carousel .vibe-block-design-wizard-preview__item--5,
.vibe-block-design-wizard-preview--carousel .vibe-block-design-wizard-preview__item--6 {
  display: none;
}

.vibe-block-design-wizard-preview--grid,
.vibe-block-design-wizard-preview--mosaic {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 5px;
}

.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__item--1 {
  grid-row: span 2;
}

.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__item--2 {
  grid-column: span 2;
}

.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__item--6 {
  display: none;
}

.vibe-block-design-wizard-preview--split {
  grid-template-columns: 1.15fr 0.85fr;
  grid-template-rows: 1fr 9px 9px;
  gap: 5px;
}

.vibe-block-design-wizard-preview--split .vibe-block-design-wizard-preview__item--1 {
  grid-row: 1 / 4;
}

.vibe-block-design-wizard-preview--split .vibe-block-design-wizard-preview__item--5,
.vibe-block-design-wizard-preview--split .vibe-block-design-wizard-preview__item--6 {
  display: none;
}

.vibe-block-design-wizard-preview--stack {
  display: block;
}

.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item {
  position: absolute;
  top: 11px;
  width: 55px;
  height: 43px;
}

.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--1 { left: 14px; transform: rotate(-7deg); }
.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--2 { left: 31px; z-index: 2; }
.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--3 { left: 48px; transform: rotate(7deg); }
.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item:nth-child(n + 4) { display: none; }

.vibe-block-design-wizard-preview--timeline {
  grid-template-columns: 12px 1fr;
  grid-template-rows: repeat(3, 1fr);
  gap: 5px 7px;
}

.vibe-block-design-wizard-preview--timeline::after {
  position: absolute;
  top: 13px;
  bottom: 13px;
  left: 13px;
  width: 2px;
  background: #84a1ef;
  content: '';
  z-index: -1;
}

.vibe-block-design-wizard-preview--timeline .vibe-block-design-wizard-preview__item:nth-child(odd) {
  border-radius: 50%;
  background: #527cf0;
}

.vibe-block-design-wizard-preview--marquee {
  grid-template-columns: repeat(6, 40px);
  gap: 6px;
  align-items: center;
}

.vibe-block-design-wizard-preview--marquee .vibe-block-design-wizard-preview__item {
  height: 38px;
  border-radius: 8px;
}

.vibe-block-design-wizard-preview--spotlight {
  grid-template-columns: 18px 1fr 18px;
  grid-template-rows: 1fr 10px;
  gap: 5px;
}

.vibe-block-design-wizard-preview--spotlight .vibe-block-design-wizard-preview__item--2 {
  grid-row: span 2;
  border-radius: 8px;
}

.vibe-block-design-wizard-preview--spotlight .vibe-block-design-wizard-preview__item:nth-child(n + 6) { display: none; }

.vibe-block-design-wizard-preview--canvas,
.vibe-block-design-wizard-preview--custom {
  display: block;
}

.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item {
  position: absolute;
  border-radius: 50%;
}

.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--1,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--1 {
  top: 17px;
  left: 41px;
  width: 35px;
  height: 35px;
}

.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item:nth-child(n + 2),
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item:nth-child(n + 2) {
  width: 9px;
  height: 9px;
  background: #718fe8;
}

.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--2,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--2 { top: 9px; left: 25px; }
.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--3,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--3 { top: 15px; right: 23px; }
.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--4,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--4 { bottom: 10px; left: 24px; }
.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--5,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--5 { right: 19px; bottom: 13px; }
.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--6,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--6 { top: 7px; left: 55px; }

.vibe-block-design-wizard-preview--motion-subtle .vibe-block-design-wizard-preview__item,
.vibe-block-design-wizard-preview--motion-custom .vibe-block-design-wizard-preview__item {
  animation: vibe-block-design-wizard-float 2.7s ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-reveal .vibe-block-design-wizard-preview__item {
  animation: vibe-block-design-wizard-reveal 2.7s ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-parallax .vibe-block-design-wizard-preview__item {
  animation: vibe-block-design-wizard-parallax 2.7s ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-parallax .vibe-block-design-wizard-preview__item:nth-child(2n) {
  animation-direction: alternate-reverse;
}

.vibe-block-design-wizard-preview--motion-tilt .vibe-block-design-wizard-preview__item {
  animation: vibe-block-design-wizard-tilt 2.7s ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-particles .vibe-block-design-wizard-preview__item {
  animation: vibe-block-design-wizard-particle 2.4s ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-morph .vibe-block-design-wizard-preview__item {
  animation: vibe-block-design-wizard-morph 2.7s ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-slide .vibe-block-design-wizard-preview__item,
.vibe-block-design-wizard-preview--motion-marquee .vibe-block-design-wizard-preview__item {
  animation: vibe-block-design-wizard-slide 2.8s ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--intensity-low .vibe-block-design-wizard-preview__item { animation-duration: 4.4s; }
.vibe-block-design-wizard-preview--intensity-high .vibe-block-design-wizard-preview__item { animation-duration: 1.7s; }
.vibe-block-design-wizard-preview__item:nth-child(2n) { animation-delay: -0.6s; }

.vibe-block-design-wizard-card--static .vibe-block-design-wizard-preview__item {
  animation-play-state: paused;
}

@keyframes vibe-block-design-wizard-float {
  from { translate: 0 1px; }
  to { translate: 0 -3px; }
}

@keyframes vibe-block-design-wizard-slide {
  from { translate: -3px 0; }
  to { translate: 4px 0; }
}

@keyframes vibe-block-design-wizard-reveal {
  from { opacity: 0.45; translate: 0 4px; }
  to { opacity: 1; translate: 0 0; }
}

@keyframes vibe-block-design-wizard-parallax {
  from { translate: -3px -1px; }
  to { translate: 4px 2px; }
}

@keyframes vibe-block-design-wizard-tilt {
  from { rotate: -3deg; translate: 0 1px; }
  to { rotate: 3deg; translate: 0 -2px; }
}

@keyframes vibe-block-design-wizard-particle {
  from { scale: 0.75; translate: -2px 2px; }
  to { scale: 1.08; translate: 3px -3px; }
}

@keyframes vibe-block-design-wizard-morph {
  from { border-radius: 4px 12px 4px 12px; scale: 0.96; }
  to { border-radius: 13px 4px 13px 4px; scale: 1.02; }
}

/* Semantic preview layer: layout controls composition, motif controls content, motion controls behaviour. */
.vibe-block-design-wizard-preview {
  --vibe-block-design-wizard-motion-distance: 4px;
  --vibe-block-design-wizard-motion-duration: 3s;
  display: block;
  padding: 0;
  background: linear-gradient(145deg, #e8efff 0%, #f6edff 100%);
}

.vibe-block-design-wizard-preview--intensity-low {
  --vibe-block-design-wizard-motion-distance: 2px;
  --vibe-block-design-wizard-motion-duration: 4.6s;
}

.vibe-block-design-wizard-preview--intensity-high {
  --vibe-block-design-wizard-motion-distance: 8px;
  --vibe-block-design-wizard-motion-duration: 1.8s;
}

.vibe-block-design-wizard-preview__glow {
  position: absolute;
  inset: -22px auto auto -18px;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: rgba(90, 129, 255, 0.2);
  filter: blur(12px);
}

.vibe-block-design-wizard-preview__stage {
  position: absolute;
  inset: 8px;
  z-index: 1;
  display: grid;
  gap: 5px;
  transform-origin: center;
}

.vibe-block-design-wizard-preview .vibe-block-design-wizard-preview__item {
  position: static;
  display: block;
  width: auto;
  height: auto;
  min-width: 0;
  min-height: 0;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 2px 7px rgba(50, 75, 130, 0.14);
  transform: none;
}

.vibe-block-design-wizard-preview--carousel .vibe-block-design-wizard-preview__stage {
  inset-inline: -14px;
  grid-template-columns: 19px 1fr 1fr 19px;
  align-items: center;
}

.vibe-block-design-wizard-preview--carousel .vibe-block-design-wizard-preview__item {
  height: 47px;
  border-radius: 8px;
}

.vibe-block-design-wizard-preview--carousel .vibe-block-design-wizard-preview__item:nth-child(n + 5) {
  display: none;
}

.vibe-block-design-wizard-preview--grid .vibe-block-design-wizard-preview__stage,
.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__stage {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__item--1 {
  grid-row: span 2;
}

.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__item--2 {
  grid-column: span 2;
}

.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__item--6 {
  display: none;
}

.vibe-block-design-wizard-preview--split .vibe-block-design-wizard-preview__stage {
  grid-template-columns: 1.15fr 0.85fr;
  grid-template-rows: 1fr 9px 9px;
}

.vibe-block-design-wizard-preview--split .vibe-block-design-wizard-preview__item--1 {
  grid-row: 1 / 4;
  border-radius: 8px;
}

.vibe-block-design-wizard-preview--split .vibe-block-design-wizard-preview__item:nth-child(n + 5) {
  display: none;
}

.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__stage {
  display: block;
}

.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item {
  position: absolute;
  top: 3px;
  width: 55px;
  height: 43px;
  border-radius: 8px;
}

.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--1 { left: 7px; rotate: -8deg; }
.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--2 { left: 24px; z-index: 2; }
.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--3 { left: 41px; rotate: 8deg; }
.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item:nth-child(n + 4) { display: none; }

.vibe-block-design-wizard-preview--timeline .vibe-block-design-wizard-preview__stage {
  grid-template-columns: 11px 1fr;
  grid-template-rows: repeat(3, 1fr);
  gap: 5px 7px;
}

.vibe-block-design-wizard-preview--timeline .vibe-block-design-wizard-preview__stage::before {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  width: 2px;
  border-radius: 2px;
  background: #89a5ef;
  content: '';
}

.vibe-block-design-wizard-preview--timeline .vibe-block-design-wizard-preview__item:nth-child(odd) {
  z-index: 1;
  border-radius: 50%;
  background: #527cf0;
}

.vibe-block-design-wizard-preview--marquee .vibe-block-design-wizard-preview__stage {
  inset-inline: -34px;
  display: flex;
  align-items: center;
  width: 238px;
}

.vibe-block-design-wizard-preview--marquee .vibe-block-design-wizard-preview__item {
  width: 34px;
  height: 39px;
  flex: 0 0 auto;
  border-radius: 8px;
}

.vibe-block-design-wizard-preview--spotlight .vibe-block-design-wizard-preview__stage {
  grid-template-columns: 17px 1fr 17px;
  grid-template-rows: 1fr 9px;
}

.vibe-block-design-wizard-preview--spotlight .vibe-block-design-wizard-preview__item--2 {
  grid-row: span 2;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(62, 92, 166, 0.25);
}

.vibe-block-design-wizard-preview--spotlight .vibe-block-design-wizard-preview__item:nth-child(n + 6) {
  display: none;
}

.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__stage,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__stage {
  display: block;
}

.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item {
  position: absolute;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #718fe8;
  transform-origin: 51px 26px;
}

.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--1,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--1 {
  top: 9px;
  left: 34px;
  width: 35px;
  height: 35px;
  background: linear-gradient(135deg, #7397ff, #c28cff);
}

.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--2,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--2 { top: 1px; left: 18px; }
.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--3,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--3 { top: 7px; right: 15px; }
.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--4,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--4 { bottom: 1px; left: 18px; }
.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--5,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--5 { right: 11px; bottom: 4px; }
.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--6,
.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--6 { top: 0; left: 49px; }

/* Motifs make otherwise similar layouts communicate different content. */
.vibe-block-design-wizard-preview--motif-gallery .vibe-block-design-wizard-preview__item,
.vibe-block-design-wizard-preview--motif-product .vibe-block-design-wizard-preview__item--1 {
  background: linear-gradient(145deg, #7aa0ff, #d49be6 72%, #f6d4b7);
}

.vibe-block-design-wizard-preview--motif-gallery .vibe-block-design-wizard-preview__item::after,
.vibe-block-design-wizard-preview--motif-product .vibe-block-design-wizard-preview__item--1::after {
  display: block;
  width: 55%;
  height: 4px;
  margin: calc(100% - 8px) 4px 0;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.75);
  content: '';
}

.vibe-block-design-wizard-preview--motif-cards .vibe-block-design-wizard-preview__item::before {
  display: block;
  height: 34%;
  border-radius: inherit;
  background: linear-gradient(135deg, #84a6ff, #b694ef);
  content: '';
}

.vibe-block-design-wizard-preview--motif-character .vibe-block-design-wizard-preview__item--1 {
  border: 5px solid rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  background: linear-gradient(145deg, #789cff, #bd91e8);
}

.vibe-block-design-wizard-preview--motif-character .vibe-block-design-wizard-preview__item--2,
.vibe-block-design-wizard-preview--motif-character .vibe-block-design-wizard-preview__item--3,
.vibe-block-design-wizard-preview--motif-content .vibe-block-design-wizard-preview__item:nth-child(n + 2) {
  align-self: center;
  height: 6px;
  box-shadow: none;
}

.vibe-block-design-wizard-preview--motif-product .vibe-block-design-wizard-preview__item--3,
.vibe-block-design-wizard-preview--motif-cta .vibe-block-design-wizard-preview__item--3,
.vibe-block-design-wizard-preview--motif-cta .vibe-block-design-wizard-preview__item--6 {
  align-self: center;
  height: 9px;
  border-radius: 999px;
  background: #4f7af0;
}

.vibe-block-design-wizard-preview--motif-timeline .vibe-block-design-wizard-preview__item:nth-child(odd) {
  border-radius: 50%;
  background: #527cf0;
}

.vibe-block-design-wizard-preview--motif-abstract .vibe-block-design-wizard-preview__item {
  background: linear-gradient(135deg, #6e94fb, #bb8dea);
}

.vibe-block-design-wizard-preview--accent-image .vibe-block-design-wizard-preview__glow {
  background: rgba(183, 108, 234, 0.25);
}

.vibe-block-design-wizard-preview--accent-cta .vibe-block-design-wizard-preview__motion-cue,
.vibe-block-design-wizard-preview--accent-motion .vibe-block-design-wizard-preview__motion-cue {
  border-color: rgba(62, 102, 216, 0.58);
  background-color: #4d79ee;
}

/* Motion families are intentionally different rather than variations of one float. */
.vibe-block-design-wizard-preview--motion-subtle .vibe-block-design-wizard-preview__item {
  animation: vibe-block-design-wizard-semantic-float var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-slide .vibe-block-design-wizard-preview__stage {
  animation: vibe-block-design-wizard-semantic-slide var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-reveal .vibe-block-design-wizard-preview__item {
  animation: vibe-block-design-wizard-semantic-reveal var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite;
}

.vibe-block-design-wizard-preview--motion-reveal .vibe-block-design-wizard-preview__item:nth-child(2n) { animation-delay: -0.45s; }
.vibe-block-design-wizard-preview--motion-reveal .vibe-block-design-wizard-preview__item:nth-child(3n) { animation-delay: -0.9s; }

.vibe-block-design-wizard-preview--motion-parallax .vibe-block-design-wizard-preview__item:nth-child(odd) {
  animation: vibe-block-design-wizard-semantic-parallax-forward var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-parallax .vibe-block-design-wizard-preview__item:nth-child(even) {
  animation: vibe-block-design-wizard-semantic-parallax-back var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-tilt .vibe-block-design-wizard-preview__stage {
  animation: vibe-block-design-wizard-semantic-tilt var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-marquee .vibe-block-design-wizard-preview__stage {
  animation: vibe-block-design-wizard-semantic-marquee var(--vibe-block-design-wizard-motion-duration) linear infinite;
}

.vibe-block-design-wizard-preview--motion-particles .vibe-block-design-wizard-preview__item:nth-child(n + 2) {
  animation: vibe-block-design-wizard-semantic-orbit var(--vibe-block-design-wizard-motion-duration) linear infinite;
}

.vibe-block-design-wizard-preview--motion-particles .vibe-block-design-wizard-preview__item:nth-child(2n) {
  animation-direction: reverse;
  animation-duration: calc(var(--vibe-block-design-wizard-motion-duration) * 1.3);
}

.vibe-block-design-wizard-preview--motion-morph .vibe-block-design-wizard-preview__item {
  animation: vibe-block-design-wizard-semantic-morph var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-custom .vibe-block-design-wizard-preview__glow {
  animation: vibe-block-design-wizard-semantic-pulse var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview__motion-cue {
  display: none !important;
}

.vibe-block-design-wizard-preview--motion-none .vibe-block-design-wizard-preview__motion-cue {
  display: none;
}

.vibe-block-design-wizard-preview--motion-slide .vibe-block-design-wizard-preview__motion-cue,
.vibe-block-design-wizard-preview--motion-marquee .vibe-block-design-wizard-preview__motion-cue {
  width: 20px;
  border-radius: 999px;
  animation: vibe-block-design-wizard-semantic-cue-slide var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-reveal .vibe-block-design-wizard-preview__motion-cue {
  animation: vibe-block-design-wizard-semantic-cue-reveal var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite;
}

.vibe-block-design-wizard-preview--motion-tilt .vibe-block-design-wizard-preview__motion-cue {
  border-radius: 2px;
  animation: vibe-block-design-wizard-semantic-cue-tilt var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;
}

.vibe-block-design-wizard-preview--motion-particles .vibe-block-design-wizard-preview__motion-cue {
  border: 0;
  background: #6488ef;
  box-shadow: -8px 3px 0 -1px #9a7ee3, 4px -7px 0 -2px #6488ef;
  animation: vibe-block-design-wizard-semantic-cue-particles var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;
}

.vibe-block-design-wizard-card--static .vibe-block-design-wizard-preview__stage,
.vibe-block-design-wizard-card--static .vibe-block-design-wizard-preview__item,
.vibe-block-design-wizard-card--static .vibe-block-design-wizard-preview__glow,
.vibe-block-design-wizard-card--static .vibe-block-design-wizard-preview__motion-cue {
  animation-play-state: paused;
}

@keyframes vibe-block-design-wizard-semantic-float {
  from { translate: 0 1px; }
  to { translate: 0 calc(var(--vibe-block-design-wizard-motion-distance) * -1); }
}

@keyframes vibe-block-design-wizard-semantic-slide {
  from { translate: calc(var(--vibe-block-design-wizard-motion-distance) * -1) 0; }
  to { translate: var(--vibe-block-design-wizard-motion-distance) 0; }
}

@keyframes vibe-block-design-wizard-semantic-reveal {
  0%, 18% { opacity: 0.28; translate: 0 var(--vibe-block-design-wizard-motion-distance); scale: 0.94; }
  48%, 82% { opacity: 1; translate: 0 0; scale: 1; }
  100% { opacity: 0.28; translate: 0 calc(var(--vibe-block-design-wizard-motion-distance) * -0.4); scale: 0.97; }
}

@keyframes vibe-block-design-wizard-semantic-parallax-forward {
  from { translate: calc(var(--vibe-block-design-wizard-motion-distance) * -1) -1px; }
  to { translate: var(--vibe-block-design-wizard-motion-distance) 2px; }
}

@keyframes vibe-block-design-wizard-semantic-parallax-back {
  from { translate: var(--vibe-block-design-wizard-motion-distance) 1px; }
  to { translate: calc(var(--vibe-block-design-wizard-motion-distance) * -1) -2px; }
}

@keyframes vibe-block-design-wizard-semantic-tilt {
  from { rotate: -2.5deg; scale: 0.98; }
  to { rotate: 2.5deg; scale: 1.015; }
}

@keyframes vibe-block-design-wizard-semantic-marquee {
  from { translate: -14px 0; }
  to { translate: 24px 0; }
}

@keyframes vibe-block-design-wizard-semantic-orbit {
  from { rotate: 0deg; }
  to { rotate: 360deg; }
}

@keyframes vibe-block-design-wizard-semantic-morph {
  from { border-radius: 5px 13px 5px 13px; scale: 0.94; }
  to { border-radius: 15px 5px 15px 5px; scale: 1.04; }
}

@keyframes vibe-block-design-wizard-semantic-pulse {
  from { opacity: 0.45; scale: 0.8; }
  to { opacity: 1; scale: 1.2; }
}

@keyframes vibe-block-design-wizard-semantic-cue-slide {
  from { translate: -4px 0; }
  to { translate: 2px 0; }
}

@keyframes vibe-block-design-wizard-semantic-cue-reveal {
  0%, 25% { opacity: 0.2; scale: 0.6; }
  55%, 100% { opacity: 1; scale: 1; }
}

@keyframes vibe-block-design-wizard-semantic-cue-tilt {
  from { rotate: -15deg; }
  to { rotate: 15deg; }
}

@keyframes vibe-block-design-wizard-semantic-cue-particles {
  from { translate: -2px 1px; }
  to { translate: 2px -2px; }
}

.vibe-block-design-wizard-custom {
  margin-top: 11px;
  padding: 10px;
  border: 1px solid #dbe4f7;
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.7);
}

.vibe-block-design-wizard-custom.is-active {
  border-color: #7599ff;
}

.vibe-block-design-wizard-custom label {
  display: block;
  margin-bottom: 6px;
  color: #44546e;
  font-size: 12px;
  font-weight: 700;
}

.vibe-block-design-wizard-custom textarea {
  display: block;
  width: 100%;
  min-height: 54px;
  padding: 8px 10px;
  resize: vertical;
  border: 1px solid #d9e3f5;
  border-radius: 9px;
  outline: none;
  background: #fff;
  color: #27344a;
  font: inherit;
  font-size: 12px;
  line-height: 1.45;
}

.vibe-block-design-wizard-custom textarea:focus {
  border-color: #668eff;
  box-shadow: 0 0 0 3px rgba(75, 124, 255, 0.11);
}

.vibe-block-design-wizard-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 12px;
}

.vibe-block-design-wizard-card__skip,
.vibe-block-design-wizard-card__submit {
  min-width: 116px;
  padding: 9px 16px;
  border: 0;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  transition: background 150ms ease, color 150ms ease, transform 150ms ease;
}

.vibe-block-design-wizard-card__skip {
  background: #edf2fc;
  color: #52698f;
}

.vibe-block-design-wizard-card__submit {
  background: #376df2;
  color: #fff;
}

.vibe-block-design-wizard-card__skip:not(:disabled):hover {
  background: #e0e9fa;
  color: #3b5788;
  transform: translateY(-1px);
}

.vibe-block-design-wizard-card__submit:not(:disabled):hover {
  background: #245bdc;
  transform: translateY(-1px);
}

.vibe-block-design-wizard-card__skip:disabled,
.vibe-block-design-wizard-card__submit:disabled {
  background: #bdc8de;
  color: #fff;
  cursor: not-allowed;
}

.vibe-block-design-wizard-card__answered {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  padding: 9px 11px;
  border-radius: 10px;
  background: #eaf8ef;
  color: #2d6745;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
}

.vibe-block-design-wizard-card__answered-label {
  color: #3e7554;
  font-size: 10px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.vibe-block-design-wizard-card__answered-effect {
  color: #527060;
  font-size: 11px;
  font-weight: 500;
}

.vibe-block-design-wizard-card__ready {
  margin-top: 9px;
  color: #4267b1;
  font-size: 11px;
  font-weight: 700;
  text-align: right;
}

.vibe-block-design-wizard-progress-summary {
  margin: 0 0 12px;
  padding: 9px 10px;
  border: 1px solid rgba(139, 165, 221, 0.28);
  border-radius: 12px;
  background: rgba(236, 243, 255, 0.72);
}

.vibe-block-design-wizard-progress-summary__label {
  margin-bottom: 6px;
  color: #57709f;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.055em;
  text-transform: uppercase;
}

.vibe-block-design-wizard-progress-summary ol {
  display: grid;
  gap: 5px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.vibe-block-design-wizard-progress-summary li {
  display: grid;
  grid-template-columns: 19px minmax(0, 1fr);
  align-items: start;
  gap: 7px;
}

.vibe-block-design-wizard-progress-summary__number {
  display: grid;
  width: 18px;
  height: 18px;
  place-items: center;
  border-radius: 50%;
  background: #dce8ff;
  color: #3f66b4;
  font-size: 9px;
  font-weight: 800;
}

.vibe-block-design-wizard-progress-summary__answer {
  overflow: hidden;
  color: #42526e;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.45;
  text-overflow: ellipsis;
}

.vibe-block-design-wizard-step-content {
  animation: vibe-block-design-wizard-step-enter 220ms ease-out both;
}

@keyframes vibe-block-design-wizard-step-enter {
  from { opacity: 0; translate: 0 7px; }
  to { opacity: 1; translate: 0 0; }
}

@media (max-width: 560px) {
  .vibe-block-design-wizard-card { padding: 13px; }
  .vibe-block-design-wizard-card__header { flex-direction: column; gap: 6px; }
  .vibe-block-design-wizard-option { grid-template-columns: 92px 1fr; padding-right: 28px; }
  .vibe-block-design-wizard-preview { width: 92px; }
  .vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--1 { left: 7px; }
  .vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--2 { left: 19px; }
  .vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--3 { left: 31px; }
}

@media (prefers-reduced-motion: reduce) {
  .vibe-block-design-wizard-preview__stage,
  .vibe-block-design-wizard-preview__item,
  .vibe-block-design-wizard-preview__glow,
  .vibe-block-design-wizard-preview__motion-cue,
  .vibe-block-design-wizard-step-content,
  .vibe-block-art-mascot,
  .vibe-block-art-mascot--spin-jump,
  .vibe-block-art-mascot--hop,
  .vibe-block-art-mascot--spin-burst,
  .vibe-block-art-mascot--tilt,
  .vibe-block-art-mascot--float,
  .vibe-block-art-mascot--aura,
  .vibe-block-art-mascot--cursor-hover,
  .vibe-block-art-mascot--tap-ripple,
  .vibe-block-art-mascot--speed-dash,
  .vibe-block-art-mascot--float-smooth,
  .vibe-block-art-mascot--scroll-reveal,
  .vibe-block-art-sparkle-burst,
  .vibe-block-art-aura-rings,
  .vibe-block-art-cursor-pointer,
  .vibe-block-art-tap-ripple-group,
  .vibe-block-art-speed-streaks,
  .vibe-block-art-grid-item,
  .vibe-block-art-carousel-track,
  .vibe-block-art-vortex,
  .vibe-block-art-firefly {
    animation: none !important;
  }

  .vibe-block-design-wizard-option,
  .vibe-block-design-wizard-card__skip,
  .vibe-block-design-wizard-card__submit { transition: none; }
}

`, "",{"version":3,"sources":["webpack://./src/styles/vibe-block-design-wizard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0EAA0E;EAC1E,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,qDAAqD;EACrD,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,qFAAqF;EACrF,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE,qFAAqF;EACrF,yCAAyC;EACzC,mDAAmD;AACrD;;AAEA;EACE,qFAAqF;EACrF,yCAAyC;EACzC,mDAAmD;AACrD;;AAEA;EACE,wEAAwE;EACxE,0CAA0C;EAC1C,mDAAmD;AACrD;;AAEA;EACE,wEAAwE;EACxE,0CAA0C;EAC1C,mDAAmD;AACrD;;AAEA;EACE,qFAAqF;EACrF,yCAAyC;EACzC,mDAAmD;AACrD;;AAEA;EACE,wEAAwE;EACxE,yCAAyC;EACzC,mDAAmD;AACrD;;AAEA;;;EAGE,qFAAqF;EACrF,yCAAyC;EACzC,mDAAmD;AACrD;;AAEA,iCAAiC;AACjC;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,4CAA4C,EAAE;AACtD;;AAEA,kEAAkE;AAClE;EACE;IACE,iDAAiD;EACnD;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,6DAA6D;EAC/D;EACA;IACE,4DAA4D;EAC9D;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,mDAAmD;EACrD;AACF;;AAEA,wEAAwE;AACxE;EACE;IACE,oCAAoC;EACtC;EACA;IACE,8CAA8C;EAChD;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,8CAA8C;EAChD;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA,yEAAyE;AACzE;EACE;IACE,iDAAiD;EACnD;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,6DAA6D;EAC/D;EACA;IACE,6DAA6D;EAC/D;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,mDAAmD;EACrD;AACF;;AAEA;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,oCAAoC;IACpC,sDAAsD;EACxD;EACA;IACE,UAAU;IACV,mCAAmC;EACrC;AACF;;AAEA,2BAA2B;AAC3B;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,yCAAyC,EAAE;EACjD,MAAM,wCAAwC,EAAE;AAClD;;AAEA;EACE,4EAA4E;EAC5E,2BAA2B;AAC7B;;AAEA;EACE,oEAAoE;EACpE,2BAA2B;AAC7B;;AAEA;EACE,+EAA+E;EAC/E,2BAA2B;AAC7B;;AAEA;EACE,uEAAuE;EACvE,2BAA2B;AAC7B;;AAEA;EACE,mDAAmD;EACnD,2BAA2B;AAC7B;;AAEA;EACE,mDAAmD;EACnD,2BAA2B;AAC7B;;AAEA;EACE,kDAAkD;EAClD,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,uEAAuE;EACvE,2BAA2B;AAC7B;;AAEA;EACE,kEAAkE;EAClE,2BAA2B;AAC7B;;AAEA;EACE,qEAAqE;EACrE,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,0DAA0D;EAC1D,2BAA2B;AAC7B;;AAEA;EACE,2DAA2D;EAC3D,2BAA2B;AAC7B;;AAEA;;EAEE,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,WAAW,iCAAiC,EAAE,qDAAqD,EAAE;EACrG,MAAM,uCAAuC,EAAE,sDAAsD,EAAE;AACzG;;AAEA;EACE,WAAW,sBAAsB,EAAE,YAAY,EAAE;EACjD,MAAM,qBAAqB,EAAE,aAAa,EAAE;AAC9C;;AAEA;EACE,WAAW,+BAA+B,EAAE,YAAY,EAAE;EAC1D,WAAW,0BAA0B,EAAE,UAAU,EAAE,qDAAqD,EAAE;AAC5G;;AAEA;EACE,UAAU,qCAAqC,EAAE;EACjD,WAAW,qDAAqD,EAAE;EAClE,YAAY,qCAAqC,EAAE;AACrD;;AAEA;EACE,UAAU,mBAAmB,EAAE;EAC/B,MAAM,4BAA4B,EAAE;EACpC,MAAM,6CAA6C,EAAE;EACrD,MAAM,iCAAiC,EAAE;EACzC,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,UAAU,qBAAqB,EAAE,UAAU,EAAE;EAC7C,MAAM,YAAY,EAAE;EACpB,YAAY,qBAAqB,EAAE,UAAU,EAAE;AACjD;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,6CAA6C,EAAE;EACrD,MAAM,uCAAuC,EAAE;EAC/C,MAAM,0BAA0B,EAAE;EAClC,MAAM,wBAAwB,EAAE;AAClC;;AAEA;EACE,UAAU,UAAU,EAAE,sBAAsB,EAAE;EAC9C,WAAW,UAAU,EAAE,sBAAsB,EAAE;EAC/C,YAAY,UAAU,EAAE,sBAAsB,EAAE;AAClD;;AAEA;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,4CAA4C,EAAE;AACtD;;AAEA;EACE,UAAU,0BAA0B,EAAE,YAAY,EAAE;EACpD,WAAW,2BAA2B,EAAE,UAAU,EAAE;EACpD,OAAO,0BAA0B,EAAE,YAAY,EAAE;AACnD;;AAEA;EACE,oDAAoD;AACtD;AACA,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,qBAAqB,EAAE;;AAEtD;EACE,WAAW,mBAAmB,EAAE,aAAa,EAAE;EAC/C,MAAM,sBAAsB,EAAE,UAAU,EAAE,sDAAsD,EAAE;AACpG;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,UAAU,wBAAwB,EAAE;EACpC,WAAW,4BAA4B,EAAE;EACzC,YAAY,wBAAwB,EAAE;AACxC;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,oDAAoD;AACtD;AACA,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,qBAAqB,EAAE;;AAEpD;EACE,KAAK,2BAA2B,EAAE,UAAU,EAAE;EAC9C,WAAW,UAAU,EAAE,oCAAoC,EAAE;EAC7D,OAAO,4BAA4B,EAAE,UAAU,EAAE;AACnD;;AAEA;EACE,WAAW,aAAa,EAAE,mBAAmB,EAAE;EAC/C,MAAM,aAAa,EAAE,sBAAsB,EAAE;AAC/C;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,6BAA6B,EAAE;AACvC;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,iCAAiC,EAAE;AAC3C;;AAEA;EACE,WAAW,mBAAmB,EAAE,aAAa,EAAE;EAC/C,MAAM,qBAAqB,EAAE,YAAY,EAAE;AAC7C;;AAEA;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,0CAA0C,EAAE;AACpD;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,WAAW,mBAAmB,EAAE,sDAAsD,EAAE;EACxF,MAAM,sBAAsB,EAAE,qDAAqD,EAAE;AACvF;;AAEA;EACE,oDAAoD;EACpD,+BAA+B;AACjC;;AAEA;EACE,yDAAyD;EACzD,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,sDAAsD;EACtD,wBAAwB;AAC1B;;AAEA;EACE,2DAA2D;EAC3D,wBAAwB;AAC1B;;AAEA;EACE,kDAAkD;EAClD,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;;EAEE,qDAAqD;AACvD;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,qCAAqC;EACrC,kCAAkC;EAClC,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA,sFAAsF,UAAU,EAAE,wBAAwB,EAAE;AAC5H,sFAAsF,UAAU,EAAE,UAAU,EAAE;AAC9G,sFAAsF,UAAU,EAAE,uBAAuB,EAAE;AAC3H,oGAAoG,aAAa,EAAE;;AAEnH;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wGAAwG,aAAa,EAAE;;AAEvH;;EAEE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;uFACuF,QAAQ,EAAE,UAAU,EAAE;AAC7G;uFACuF,SAAS,EAAE,WAAW,EAAE;AAC/G;uFACuF,YAAY,EAAE,UAAU,EAAE;AACjH;uFACuF,WAAW,EAAE,YAAY,EAAE;AAClH;uFACuF,QAAQ,EAAE,UAAU,EAAE;;AAE7G;;EAEE,6EAA6E;AAC/E;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;;EAEE,6EAA6E;AAC/E;;AAEA,2FAA2F,wBAAwB,EAAE;AACrH,4FAA4F,wBAAwB,EAAE;AACtH,wDAAwD,sBAAsB,EAAE;;AAEhF;EACE,4BAA4B;AAC9B;;AAEA;EACE,OAAO,gBAAgB,EAAE;EACzB,KAAK,iBAAiB,EAAE;AAC1B;;AAEA;EACE,OAAO,iBAAiB,EAAE;EAC1B,KAAK,gBAAgB,EAAE;AACzB;;AAEA;EACE,OAAO,aAAa,EAAE,gBAAgB,EAAE;EACxC,KAAK,UAAU,EAAE,cAAc,EAAE;AACnC;;AAEA;EACE,OAAO,oBAAoB,EAAE;EAC7B,KAAK,kBAAkB,EAAE;AAC3B;;AAEA;EACE,OAAO,aAAa,EAAE,gBAAgB,EAAE;EACxC,KAAK,YAAY,EAAE,iBAAiB,EAAE;AACxC;;AAEA;EACE,OAAO,WAAW,EAAE,mBAAmB,EAAE;EACzC,KAAK,WAAW,EAAE,mBAAmB,EAAE;AACzC;;AAEA;EACE,OAAO,gCAAgC,EAAE,WAAW,EAAE;EACtD,KAAK,gCAAgC,EAAE,WAAW,EAAE;AACtD;;AAEA,4GAA4G;AAC5G;EACE,+CAA+C;EAC/C,8CAA8C;EAC9C,cAAc;EACd,UAAU;EACV,6DAA6D;AAC/D;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,aAAa;EACb,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,sFAAsF,SAAS,EAAE,aAAa,EAAE;AAChH,sFAAsF,UAAU,EAAE,UAAU,EAAE;AAC9G,sFAAsF,UAAU,EAAE,YAAY,EAAE;AAChH,oGAAoG,aAAa,EAAE;;AAEnH;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,qDAAqD;AACvD;;AAEA;uFACuF,QAAQ,EAAE,UAAU,EAAE;AAC7G;uFACuF,QAAQ,EAAE,WAAW,EAAE;AAC9G;uFACuF,WAAW,EAAE,UAAU,EAAE;AAChH;uFACuF,WAAW,EAAE,WAAW,EAAE;AACjH;uFACuF,MAAM,EAAE,UAAU,EAAE;;AAE3G,yEAAyE;AACzE;;EAEE,kEAAkE;AACpE;;AAEA;;EAEE,cAAc;EACd,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;;;EAGE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA,qFAAqF;AACrF;EACE,iIAAiI;AACnI;;AAEA;EACE,iIAAiI;AACnI;;AAEA;EACE,wHAAwH;AAC1H;;AAEA,yGAAyG,uBAAuB,EAAE;AAClI,yGAAyG,sBAAsB,EAAE;;AAEjI;EACE,4IAA4I;AAC9I;;AAEA;EACE,yIAAyI;AAC3I;;AAEA;EACE,gIAAgI;AAClI;;AAEA;EACE,oHAAoH;AACtH;;AAEA;EACE,kHAAkH;AACpH;;AAEA;EACE,4BAA4B;EAC5B,+EAA+E;AACjF;;AAEA;EACE,iIAAiI;AACnI;;AAEA;EACE,iIAAiI;AACnI;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB,qIAAqI;AACvI;;AAEA;EACE,4HAA4H;AAC9H;;AAEA;EACE,kBAAkB;EAClB,oIAAoI;AACtI;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,4DAA4D;EAC5D,yIAAyI;AAC3I;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;EACE,OAAO,gBAAgB,EAAE;EACzB,KAAK,uEAAuE,EAAE;AAChF;;AAEA;EACE,OAAO,uEAAuE,EAAE;EAChF,KAAK,4DAA4D,EAAE;AACrE;;AAEA;EACE,UAAU,aAAa,EAAE,4DAA4D,EAAE,WAAW,EAAE;EACpG,WAAW,UAAU,EAAE,cAAc,EAAE,QAAQ,EAAE;EACjD,OAAO,aAAa,EAAE,yEAAyE,EAAE,WAAW,EAAE;AAChH;;AAEA;EACE,OAAO,0EAA0E,EAAE;EACnF,KAAK,8DAA8D,EAAE;AACvE;;AAEA;EACE,OAAO,8DAA8D,EAAE;EACvE,KAAK,0EAA0E,EAAE;AACnF;;AAEA;EACE,OAAO,eAAe,EAAE,WAAW,EAAE;EACrC,KAAK,cAAc,EAAE,YAAY,EAAE;AACrC;;AAEA;EACE,OAAO,kBAAkB,EAAE;EAC3B,KAAK,iBAAiB,EAAE;AAC1B;;AAEA;EACE,OAAO,YAAY,EAAE;EACrB,KAAK,cAAc,EAAE;AACvB;;AAEA;EACE,OAAO,gCAAgC,EAAE,WAAW,EAAE;EACtD,KAAK,gCAAgC,EAAE,WAAW,EAAE;AACtD;;AAEA;EACE,OAAO,aAAa,EAAE,UAAU,EAAE;EAClC,KAAK,UAAU,EAAE,UAAU,EAAE;AAC/B;;AAEA;EACE,OAAO,iBAAiB,EAAE;EAC1B,KAAK,gBAAgB,EAAE;AACzB;;AAEA;EACE,UAAU,YAAY,EAAE,UAAU,EAAE;EACpC,YAAY,UAAU,EAAE,QAAQ,EAAE;AACpC;;AAEA;EACE,OAAO,cAAc,EAAE;EACvB,KAAK,aAAa,EAAE;AACtB;;AAEA;EACE,OAAO,mBAAmB,EAAE;EAC5B,KAAK,mBAAmB,EAAE;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yEAAyE;AAC3E;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,OAAO,UAAU,EAAE,gBAAgB,EAAE;EACrC,KAAK,UAAU,EAAE,cAAc,EAAE;AACnC;;AAEA;EACE,iCAAiC,aAAa,EAAE;EAChD,yCAAyC,sBAAsB,EAAE,QAAQ,EAAE;EAC3E,mCAAmC,+BAA+B,EAAE,mBAAmB,EAAE;EACzF,oCAAoC,WAAW,EAAE;EACjD,sFAAsF,SAAS,EAAE;EACjG,sFAAsF,UAAU,EAAE;EAClG,sFAAsF,UAAU,EAAE;AACpG;;AAEA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;IA0BE,0BAA0B;EAC5B;;EAEA;;2CAEyC,gBAAgB,EAAE;AAC7D","sourcesContent":[".vibe-block-design-wizard-card {\n  width: 100%;\n  max-width: 550px;\n  margin: 14px 0 4px;\n  padding: 16px;\n  border: 1px solid #cbdcff;\n  border-radius: 20px;\n  background: linear-gradient(145deg, #f8fbff 0%, #f4f7ff 55%, #f9f5ff 100%);\n  box-shadow: 0 10px 30px rgba(34, 77, 163, 0.09);\n}\n\n.vibe-block-design-wizard-card__header {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n.vibe-block-design-wizard-card--answered {\n  padding: 13px 15px;\n  background: linear-gradient(145deg, #f8fbff 0%, #f2fbf6 100%);\n}\n\n.vibe-block-design-wizard-card__header--answered {\n  align-items: flex-start;\n  margin-bottom: 9px;\n}\n\n.vibe-block-design-wizard-card__answered-check {\n  display: grid;\n  width: 24px;\n  height: 24px;\n  flex: 0 0 auto;\n  place-items: center;\n  border-radius: 50%;\n  background: #dff4e7;\n  color: #287447;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.vibe-block-design-wizard-card__eyebrow {\n  margin-bottom: 5px;\n  color: #4267b1;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.vibe-block-design-wizard-card__question {\n  margin: 0;\n  color: #1f2e49;\n  font-size: 17px;\n  font-weight: 700;\n  line-height: 1.35;\n}\n\n.vibe-block-design-wizard-card__helper {\n  margin: 6px 0 0;\n  color: #66738b;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.vibe-block-design-wizard-card__step-dots {\n  display: flex;\n  flex: 0 0 auto;\n  gap: 5px;\n  padding-top: 5px;\n}\n\n.vibe-block-design-wizard-card__step-dots span {\n  width: 18px;\n  height: 5px;\n  border-radius: 999px;\n  background: #dce5f7;\n}\n\n.vibe-block-design-wizard-card__step-dots span.is-active {\n  background: #4b7cff;\n}\n\n.vibe-block-design-wizard-options {\n  display: grid;\n  gap: 9px;\n}\n\n.vibe-block-design-wizard-option {\n  position: relative;\n  display: grid;\n  grid-template-columns: 118px 1fr;\n  align-items: center;\n  width: 100%;\n  min-height: 98px;\n  padding: 9px 34px 9px 9px;\n  overflow: hidden;\n  border: 1px solid #dbe4f7;\n  border-radius: 15px;\n  background: rgba(255, 255, 255, 0.88);\n  color: inherit;\n  text-align: left;\n  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n}\n\n.vibe-block-design-wizard-option:not(:disabled):hover {\n  border-color: #92afff;\n  box-shadow: 0 7px 18px rgba(53, 93, 176, 0.11);\n  transform: translateY(-1px);\n}\n\n.vibe-block-design-wizard-option.is-selected {\n  border-color: #4b7cff;\n  box-shadow: 0 0 0 2px rgba(75, 124, 255, 0.13);\n}\n\n.vibe-block-design-wizard-option:disabled {\n  cursor: default;\n}\n\n.vibe-block-design-wizard-option__copy {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  padding-left: 12px;\n}\n\n.vibe-block-design-wizard-option__title {\n  color: #263654;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.4;\n}\n\n.vibe-block-design-wizard-option__title span:not(.vibe-block-design-wizard-option__badge-recommended):not(.vibe-block-design-wizard-option__badge-star),\n.vibe-block-design-wizard-option__explanation {\n  color: #596983;\n  font-weight: 500;\n}\n\n.vibe-block-design-wizard-option__title .vibe-block-design-wizard-option__badge-recommended {\n  display: inline-flex;\n  align-items: center;\n  gap: 3.5px;\n  padding: 1.5px 7px;\n  margin-left: 6px;\n  margin-right: 3px;\n  border-radius: 9999px;\n  background: #eef2ff;\n  border: 1px solid #c7d2fe;\n  color: #3730a3;\n  font-size: 10.5px;\n  font-weight: 700;\n  line-height: 1.35;\n  letter-spacing: 0.01em;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.vibe-block-design-wizard-option__badge-star {\n  color: #6366f1;\n  font-size: 9.5px;\n  line-height: 1;\n}\n\n.vibe-block-design-wizard-option.is-selected .vibe-block-design-wizard-option__badge-recommended {\n  background: #e0e7ff;\n  border-color: #a5b4fc;\n  color: #312e81;\n}\n\n.vibe-block-design-wizard-option.is-selected .vibe-block-design-wizard-option__badge-star {\n  color: #4338ca;\n}\n\n.vibe-block-design-wizard-option__effect {\n  margin-top: 5px;\n  color: #46705a;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.vibe-block-design-wizard-option__check {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: grid;\n  width: 18px;\n  height: 18px;\n  place-items: center;\n  border: 1px solid #ccd8ef;\n  border-radius: 50%;\n  background: #fff;\n  color: transparent;\n  font-size: 11px;\n}\n\n.vibe-block-design-wizard-option.is-selected .vibe-block-design-wizard-option__check {\n  border-color: #4b7cff;\n  background: #4b7cff;\n  color: #fff;\n}\n\n.vibe-block-design-wizard-preview-shell {\n  min-width: 0;\n}\n\n.vibe-block-design-wizard-preview {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 118px;\n  height: 69px;\n  padding: 0;\n  overflow: hidden;\n  border-radius: 11px;\n  background: linear-gradient(145deg, #e8efff, #f5eaff);\n  isolation: isolate;\n  transition: transform 180ms ease, box-shadow 180ms ease;\n}\n\n.vibe-block-design-wizard-option-art {\n  display: block;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.vibe-block-design-wizard-option-art-custom {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.vibe-block-design-wizard-option-art-custom svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n  max-width: 118px;\n  max-height: 69px;\n  object-fit: contain;\n}\n\n/* Dynamic motif palettes */\n.vibe-block-design-wizard-preview--motif-character {\n  background: radial-gradient(circle at 50% 30%, #2e266d 0%, #17133d 65%, #0c0a21 100%);\n  border: 1px solid rgba(165, 180, 252, 0.3);\n  box-shadow: inset 0 0 16px rgba(129, 140, 248, 0.25);\n}\n\n.vibe-block-design-wizard-preview--motif-scene {\n  background: radial-gradient(circle at 60% 30%, #1e293b 0%, #0f172a 70%, #020617 100%);\n  border: 1px solid rgba(56, 189, 248, 0.3);\n  box-shadow: inset 0 0 16px rgba(56, 189, 248, 0.22);\n}\n\n.vibe-block-design-wizard-preview--motif-particles {\n  background: radial-gradient(circle at 50% 50%, #1a103c 0%, #090d16 70%, #020617 100%);\n  border: 1px solid rgba(45, 212, 191, 0.3);\n  box-shadow: inset 0 0 16px rgba(45, 212, 191, 0.22);\n}\n\n.vibe-block-design-wizard-preview--motif-cards {\n  background: radial-gradient(circle at 50% 30%, #1e293b 0%, #0f172a 100%);\n  border: 1px solid rgba(99, 102, 241, 0.25);\n  box-shadow: inset 0 0 14px rgba(99, 102, 241, 0.18);\n}\n\n.vibe-block-design-wizard-preview--motif-gallery {\n  background: radial-gradient(circle at 50% 40%, #172554 0%, #0c1a30 100%);\n  border: 1px solid rgba(56, 189, 248, 0.25);\n  box-shadow: inset 0 0 14px rgba(56, 189, 248, 0.18);\n}\n\n.vibe-block-design-wizard-preview--motif-product {\n  background: radial-gradient(circle at 50% 25%, #27272a 0%, #18181b 70%, #09090b 100%);\n  border: 1px solid rgba(251, 191, 36, 0.3);\n  box-shadow: inset 0 0 14px rgba(251, 191, 36, 0.22);\n}\n\n.vibe-block-design-wizard-preview--motif-timeline {\n  background: radial-gradient(circle at 50% 30%, #1e1b4b 0%, #0f172a 100%);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  box-shadow: inset 0 0 14px rgba(59, 130, 246, 0.22);\n}\n\n.vibe-block-design-wizard-preview--motif-cta,\n.vibe-block-design-wizard-preview--motif-content,\n.vibe-block-design-wizard-preview--motif-abstract {\n  background: radial-gradient(circle at 70% 30%, #eef2ff 0%, #e0e7ff 55%, #f1f5f9 100%);\n  border: 1px solid rgba(99, 102, 241, 0.2);\n  box-shadow: inset 0 0 12px rgba(99, 102, 241, 0.12);\n}\n\n/* Micro-Animations for Artwork */\n@keyframes vibeMascotFloat {\n  0%, 100% { transform: translateY(0px) rotate(0deg); }\n  50% { transform: translateY(-3.2px) rotate(0.8deg); }\n}\n\n/* 1. Pirouette & Jump (360deg rotation + mid-air jump + bounce) */\n@keyframes vibeMascotSpinJump {\n  0%, 100% {\n    transform: translateY(0) rotate(0deg) scale(1, 1);\n  }\n  15% {\n    transform: translateY(2.5px) rotate(0deg) scale(1.1, 0.9);\n  }\n  42% {\n    transform: translateY(-13px) rotate(180deg) scale(0.95, 1.05);\n  }\n  65% {\n    transform: translateY(-4px) rotate(360deg) scale(0.98, 1.02);\n  }\n  78% {\n    transform: translateY(2px) rotate(360deg) scale(1.08, 0.92);\n  }\n  90% {\n    transform: translateY(0) rotate(360deg) scale(1, 1);\n  }\n}\n\n/* 2. Hop / Jump straight up (0deg rotation, clean spring and landing) */\n@keyframes vibeMascotHop {\n  0%, 100% {\n    transform: translateY(0) scale(1, 1);\n  }\n  15% {\n    transform: translateY(2.5px) scale(1.12, 0.88);\n  }\n  45% {\n    transform: translateY(-13px) scale(0.92, 1.1);\n  }\n  75% {\n    transform: translateY(1.5px) scale(1.08, 0.92);\n  }\n  88% {\n    transform: translateY(0) scale(1, 1);\n  }\n}\n\n/* 3. Double Spin + Sparkle Burst (720deg rapid pirouette + peak flash) */\n@keyframes vibeMascotDoubleSpin {\n  0%, 100% {\n    transform: translateY(0) rotate(0deg) scale(1, 1);\n  }\n  12% {\n    transform: translateY(3px) rotate(0deg) scale(1.12, 0.88);\n  }\n  38% {\n    transform: translateY(-14px) rotate(360deg) scale(0.94, 1.06);\n  }\n  62% {\n    transform: translateY(-16px) rotate(720deg) scale(0.95, 1.05);\n  }\n  80% {\n    transform: translateY(2px) rotate(720deg) scale(1.1, 0.9);\n  }\n  92% {\n    transform: translateY(0) rotate(720deg) scale(1, 1);\n  }\n}\n\n@keyframes vibeSparkleBurst {\n  0%, 30% {\n    opacity: 0;\n    transform: scale(0.2) rotate(0deg);\n  }\n  50%, 65% {\n    opacity: 1;\n    transform: scale(1.25) rotate(45deg);\n    filter: drop-shadow(0 0 8px rgba(254, 240, 138, 0.95));\n  }\n  82%, 100% {\n    opacity: 0;\n    transform: scale(1.6) rotate(90deg);\n  }\n}\n\n/* 4. Tilt / Curious sway */\n@keyframes vibeMascotTilt {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  25% { transform: translateY(-2px) rotate(-6deg); }\n  75% { transform: translateY(-2px) rotate(6deg); }\n}\n\n.vibe-block-art-mascot--spin-jump {\n  animation: vibeMascotSpinJump 2.4s cubic-bezier(0.34, 1.3, 0.64, 1) infinite;\n  transform-origin: 59px 38px;\n}\n\n.vibe-block-art-mascot--hop {\n  animation: vibeMascotHop 2.0s cubic-bezier(0.25, 1, 0.5, 1) infinite;\n  transform-origin: 59px 48px;\n}\n\n.vibe-block-art-mascot--spin-burst {\n  animation: vibeMascotDoubleSpin 2.6s cubic-bezier(0.34, 1.25, 0.64, 1) infinite;\n  transform-origin: 59px 38px;\n}\n\n.vibe-block-art-sparkle-burst {\n  animation: vibeSparkleBurst 2.6s cubic-bezier(0.16, 1, 0.3, 1) infinite;\n  transform-origin: 59px 36px;\n}\n\n.vibe-block-art-mascot--tilt {\n  animation: vibeMascotTilt 2.5s ease-in-out infinite;\n  transform-origin: 59px 44px;\n}\n\n.vibe-block-art-mascot--aura {\n  animation: vibeMascotAura 3.0s ease-in-out infinite;\n  transform-origin: 59px 38px;\n}\n\n.vibe-block-art-aura-rings {\n  animation: vibeAuraPulse 3.0s ease-in-out infinite;\n  transform-origin: 58px 38px;\n}\n\n.vibe-block-art-mascot--cursor-hover {\n  animation: vibeMascotCursorReaction 2.6s ease-in-out infinite;\n  transform-origin: 59px 44px;\n}\n\n.vibe-block-art-cursor-pointer {\n  animation: vibeCursorFloat 2.6s ease-in-out infinite;\n  transform-origin: 75px 38px;\n}\n\n.vibe-block-art-mascot--tap-ripple {\n  animation: vibeMascotTap 2.2s cubic-bezier(0.34, 1.3, 0.64, 1) infinite;\n  transform-origin: 59px 44px;\n}\n\n.vibe-block-art-tap-ripple-group {\n  animation: vibeTapWave 2.2s cubic-bezier(0.16, 1, 0.3, 1) infinite;\n  transform-origin: 58px 40px;\n}\n\n.vibe-block-art-mascot--speed-dash {\n  animation: vibeMascotDash 2.0s cubic-bezier(0.25, 1, 0.5, 1) infinite;\n  transform-origin: 59px 38px;\n}\n\n.vibe-block-art-speed-streaks {\n  animation: vibeStreaksFlash 2.0s ease-in-out infinite;\n  transform-origin: 20px 40px;\n}\n\n.vibe-block-art-mascot--float-smooth {\n  animation: vibeMascotSmoothFloat 3.8s ease-in-out infinite;\n  transform-origin: 59px 38px;\n}\n\n.vibe-block-art-mascot--scroll-reveal {\n  animation: vibeMascotScrollReveal 2.8s ease-in-out infinite;\n  transform-origin: 59px 40px;\n}\n\n.vibe-block-art-mascot--float,\n.vibe-block-art-mascot {\n  animation: vibeMascotFloat 3.2s ease-in-out infinite;\n  transform-origin: 59px 38px;\n}\n\n@keyframes vibeMascotAura {\n  0%, 100% { transform: translateY(0) scale(1); filter: drop-shadow(0 0 6px rgba(129, 140, 248, 0.5)); }\n  50% { transform: translateY(-3px) scale(1.03); filter: drop-shadow(0 0 12px rgba(192, 132, 252, 0.8)); }\n}\n\n@keyframes vibeAuraPulse {\n  0%, 100% { transform: scale(0.92); opacity: 0.5; }\n  50% { transform: scale(1.1); opacity: 0.95; }\n}\n\n@keyframes vibeCursorFloat {\n  0%, 100% { transform: translate(6px, -6px); opacity: 0.6; }\n  45%, 55% { transform: translate(0, 0); opacity: 1; filter: drop-shadow(0 2px 4px rgba(79, 70, 229, 0.4)); }\n}\n\n@keyframes vibeMascotCursorReaction {\n  0%, 40% { transform: translateY(0) rotate(0deg); }\n  50%, 70% { transform: translateY(-4px) rotate(-5deg) scale(1.05); }\n  85%, 100% { transform: translateY(0) rotate(0deg); }\n}\n\n@keyframes vibeMascotTap {\n  0%, 30% { transform: scale(1); }\n  35% { transform: scale(0.92, 1.08); }\n  45% { transform: translateY(-5px) scale(1.06, 0.95); }\n  65% { transform: translateY(0) scale(1); }\n  100% { transform: scale(1); }\n}\n\n@keyframes vibeTapWave {\n  0%, 30% { transform: scale(0.3); opacity: 0; }\n  40% { opacity: 0.9; }\n  75%, 100% { transform: scale(1.4); opacity: 0; }\n}\n\n@keyframes vibeMascotDash {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-4px) scale(0.95, 1.05); }\n  40% { transform: translateX(8px) skewX(-8deg); }\n  65% { transform: translateX(2px); }\n  80% { transform: translateX(0); }\n}\n\n@keyframes vibeStreaksFlash {\n  0%, 20% { opacity: 0; transform: scaleX(0.4); }\n  35%, 55% { opacity: 1; transform: scaleX(1.2); }\n  70%, 100% { opacity: 0; transform: scaleX(0.4); }\n}\n\n@keyframes vibeMascotSmoothFloat {\n  0%, 100% { transform: translateY(0px) rotate(0deg); }\n  50% { transform: translateY(-4.5px) rotate(1.5deg); }\n}\n\n@keyframes vibeMascotScrollReveal {\n  0%, 20% { transform: translateY(8px); opacity: 0.4; }\n  50%, 80% { transform: translateY(-2px); opacity: 1; }\n  100% { transform: translateY(8px); opacity: 0.4; }\n}\n\n.vibe-block-art-grid-item {\n  animation: vibeGridStagger 2.4s ease-in-out infinite;\n}\n.vibe-block-art-grid-item--2 { animation-delay: 0.3s; }\n.vibe-block-art-grid-item--3 { animation-delay: 0.6s; }\n.vibe-block-art-grid-item--4 { animation-delay: 0.9s; }\n\n@keyframes vibeGridStagger {\n  0%, 100% { transform: scale(1); opacity: 0.85; }\n  50% { transform: scale(1.05); opacity: 1; filter: drop-shadow(0 2px 5px rgba(99, 102, 241, 0.4)); }\n}\n\n.vibe-block-art-carousel-track {\n  animation: vibeCarouselSlide 3.2s cubic-bezier(0.45, 0, 0.55, 1) infinite;\n}\n\n@keyframes vibeCarouselSlide {\n  0%, 25% { transform: translateX(0); }\n  45%, 70% { transform: translateX(-24px); }\n  85%, 100% { transform: translateX(0); }\n}\n\n.vibe-block-art-vortex {\n  animation: vibeVortexRotate 6s linear infinite;\n  transform-origin: 59px 34px;\n}\n\n@keyframes vibeVortexRotate {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.vibe-block-art-firefly {\n  animation: vibeFireflyRise 3.0s ease-in-out infinite;\n}\n.vibe-block-art-firefly--2 { animation-delay: 0.8s; }\n.vibe-block-art-firefly--3 { animation-delay: 1.5s; }\n\n@keyframes vibeFireflyRise {\n  0% { transform: translateY(10px); opacity: 0; }\n  40%, 60% { opacity: 1; filter: drop-shadow(0 0 4px #67e8f9); }\n  100% { transform: translateY(-16px); opacity: 0; }\n}\n\n@keyframes vibeStarTwinkle {\n  0%, 100% { opacity: 0.95; transform: scale(1); }\n  50% { opacity: 0.35; transform: scale(0.72); }\n}\n\n@keyframes vibeParallaxDrift {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-3.5px); }\n}\n\n@keyframes vibeParallaxBack {\n  0%, 100% { transform: translate(0, 0); }\n  50% { transform: translate(-1.5px, 1px); }\n}\n\n@keyframes vibeParticlePulse {\n  0%, 100% { transform: scale(1); opacity: 0.95; }\n  50% { transform: scale(1.2); opacity: 0.7; }\n}\n\n@keyframes vibeCardFloat {\n  0%, 100% { transform: translateY(0px) rotate(6deg); }\n  50% { transform: translateY(-2.8px) rotate(5deg); }\n}\n\n@keyframes vibeProductHover {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-3px); }\n}\n\n@keyframes vibeCtaPulse {\n  0%, 100% { transform: scale(1); filter: drop-shadow(0 2px 5px rgba(79, 70, 229, 0.35)); }\n  50% { transform: scale(1.04); filter: drop-shadow(0 3px 8px rgba(79, 70, 229, 0.6)); }\n}\n\n.vibe-block-art-star--1 {\n  animation: vibeStarTwinkle 2.4s ease-in-out infinite;\n  transform-origin: 23.5px 23.5px;\n}\n\n.vibe-block-art-star--2 {\n  animation: vibeStarTwinkle 2.8s ease-in-out 0.8s infinite;\n  transform-origin: 93px 19px;\n}\n\n.vibe-block-art-parallax-fore {\n  animation: vibeParallaxDrift 3.4s ease-in-out infinite;\n}\n\n.vibe-block-art-parallax-back {\n  animation: vibeParallaxBack 4.5s ease-in-out infinite;\n}\n\n.vibe-block-art-node--1, .vibe-block-art-node--2, .vibe-block-art-node--4 {\n  animation: vibeParticlePulse 2.6s ease-in-out infinite;\n  transform-origin: center;\n}\n\n.vibe-block-art-node--3, .vibe-block-art-node--5 {\n  animation: vibeParticlePulse 3.1s ease-in-out 0.9s infinite;\n  transform-origin: center;\n}\n\n.vibe-block-art-card--front {\n  animation: vibeCardFloat 3.6s ease-in-out infinite;\n  transform-origin: 69px 36px;\n}\n\n.vibe-block-art-product-float {\n  animation: vibeProductHover 2.8s ease-in-out infinite;\n}\n\n.vibe-block-art-cta-btn {\n  animation: vibeCtaPulse 2.2s ease-in-out infinite;\n  transform-origin: 40px 44px;\n}\n\n.vibe-block-design-wizard-preview::before {\n  position: absolute;\n  inset: -35% 35% 20% -20%;\n  border-radius: 50%;\n  background: rgba(78, 124, 255, 0.17);\n  content: '';\n  filter: blur(9px);\n  z-index: -1;\n}\n\n.vibe-block-design-wizard-preview__item {\n  display: block;\n  min-width: 0;\n  min-height: 0;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.93);\n  box-shadow: 0 2px 7px rgba(50, 75, 130, 0.14);\n}\n\n.vibe-block-design-wizard-preview--accent-image .vibe-block-design-wizard-preview__item--1,\n.vibe-block-design-wizard-preview--accent-motion .vibe-block-design-wizard-preview__item--2 {\n  background: linear-gradient(135deg, #7397ff, #b98cff);\n}\n\n.vibe-block-design-wizard-preview--accent-content .vibe-block-design-wizard-preview__item--1,\n.vibe-block-design-wizard-preview--accent-cta .vibe-block-design-wizard-preview__item--3,\n.vibe-block-design-wizard-preview--accent-cta .vibe-block-design-wizard-preview__item--6 {\n  background: #527cf0;\n}\n\n.vibe-block-design-wizard-preview--carousel {\n  grid-template-columns: 13px 1fr 1fr 13px;\n  gap: 5px;\n  align-items: center;\n}\n\n.vibe-block-design-wizard-preview--carousel .vibe-block-design-wizard-preview__item {\n  height: 47px;\n}\n\n.vibe-block-design-wizard-preview--carousel .vibe-block-design-wizard-preview__item--5,\n.vibe-block-design-wizard-preview--carousel .vibe-block-design-wizard-preview__item--6 {\n  display: none;\n}\n\n.vibe-block-design-wizard-preview--grid,\n.vibe-block-design-wizard-preview--mosaic {\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  gap: 5px;\n}\n\n.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__item--1 {\n  grid-row: span 2;\n}\n\n.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__item--2 {\n  grid-column: span 2;\n}\n\n.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__item--6 {\n  display: none;\n}\n\n.vibe-block-design-wizard-preview--split {\n  grid-template-columns: 1.15fr 0.85fr;\n  grid-template-rows: 1fr 9px 9px;\n  gap: 5px;\n}\n\n.vibe-block-design-wizard-preview--split .vibe-block-design-wizard-preview__item--1 {\n  grid-row: 1 / 4;\n}\n\n.vibe-block-design-wizard-preview--split .vibe-block-design-wizard-preview__item--5,\n.vibe-block-design-wizard-preview--split .vibe-block-design-wizard-preview__item--6 {\n  display: none;\n}\n\n.vibe-block-design-wizard-preview--stack {\n  display: block;\n}\n\n.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item {\n  position: absolute;\n  top: 11px;\n  width: 55px;\n  height: 43px;\n}\n\n.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--1 { left: 14px; transform: rotate(-7deg); }\n.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--2 { left: 31px; z-index: 2; }\n.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--3 { left: 48px; transform: rotate(7deg); }\n.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item:nth-child(n + 4) { display: none; }\n\n.vibe-block-design-wizard-preview--timeline {\n  grid-template-columns: 12px 1fr;\n  grid-template-rows: repeat(3, 1fr);\n  gap: 5px 7px;\n}\n\n.vibe-block-design-wizard-preview--timeline::after {\n  position: absolute;\n  top: 13px;\n  bottom: 13px;\n  left: 13px;\n  width: 2px;\n  background: #84a1ef;\n  content: '';\n  z-index: -1;\n}\n\n.vibe-block-design-wizard-preview--timeline .vibe-block-design-wizard-preview__item:nth-child(odd) {\n  border-radius: 50%;\n  background: #527cf0;\n}\n\n.vibe-block-design-wizard-preview--marquee {\n  grid-template-columns: repeat(6, 40px);\n  gap: 6px;\n  align-items: center;\n}\n\n.vibe-block-design-wizard-preview--marquee .vibe-block-design-wizard-preview__item {\n  height: 38px;\n  border-radius: 8px;\n}\n\n.vibe-block-design-wizard-preview--spotlight {\n  grid-template-columns: 18px 1fr 18px;\n  grid-template-rows: 1fr 10px;\n  gap: 5px;\n}\n\n.vibe-block-design-wizard-preview--spotlight .vibe-block-design-wizard-preview__item--2 {\n  grid-row: span 2;\n  border-radius: 8px;\n}\n\n.vibe-block-design-wizard-preview--spotlight .vibe-block-design-wizard-preview__item:nth-child(n + 6) { display: none; }\n\n.vibe-block-design-wizard-preview--canvas,\n.vibe-block-design-wizard-preview--custom {\n  display: block;\n}\n\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item {\n  position: absolute;\n  border-radius: 50%;\n}\n\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--1,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--1 {\n  top: 17px;\n  left: 41px;\n  width: 35px;\n  height: 35px;\n}\n\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item:nth-child(n + 2),\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item:nth-child(n + 2) {\n  width: 9px;\n  height: 9px;\n  background: #718fe8;\n}\n\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--2,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--2 { top: 9px; left: 25px; }\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--3,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--3 { top: 15px; right: 23px; }\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--4,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--4 { bottom: 10px; left: 24px; }\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--5,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--5 { right: 19px; bottom: 13px; }\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--6,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--6 { top: 7px; left: 55px; }\n\n.vibe-block-design-wizard-preview--motion-subtle .vibe-block-design-wizard-preview__item,\n.vibe-block-design-wizard-preview--motion-custom .vibe-block-design-wizard-preview__item {\n  animation: vibe-block-design-wizard-float 2.7s ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-reveal .vibe-block-design-wizard-preview__item {\n  animation: vibe-block-design-wizard-reveal 2.7s ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-parallax .vibe-block-design-wizard-preview__item {\n  animation: vibe-block-design-wizard-parallax 2.7s ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-parallax .vibe-block-design-wizard-preview__item:nth-child(2n) {\n  animation-direction: alternate-reverse;\n}\n\n.vibe-block-design-wizard-preview--motion-tilt .vibe-block-design-wizard-preview__item {\n  animation: vibe-block-design-wizard-tilt 2.7s ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-particles .vibe-block-design-wizard-preview__item {\n  animation: vibe-block-design-wizard-particle 2.4s ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-morph .vibe-block-design-wizard-preview__item {\n  animation: vibe-block-design-wizard-morph 2.7s ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-slide .vibe-block-design-wizard-preview__item,\n.vibe-block-design-wizard-preview--motion-marquee .vibe-block-design-wizard-preview__item {\n  animation: vibe-block-design-wizard-slide 2.8s ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--intensity-low .vibe-block-design-wizard-preview__item { animation-duration: 4.4s; }\n.vibe-block-design-wizard-preview--intensity-high .vibe-block-design-wizard-preview__item { animation-duration: 1.7s; }\n.vibe-block-design-wizard-preview__item:nth-child(2n) { animation-delay: -0.6s; }\n\n.vibe-block-design-wizard-card--static .vibe-block-design-wizard-preview__item {\n  animation-play-state: paused;\n}\n\n@keyframes vibe-block-design-wizard-float {\n  from { translate: 0 1px; }\n  to { translate: 0 -3px; }\n}\n\n@keyframes vibe-block-design-wizard-slide {\n  from { translate: -3px 0; }\n  to { translate: 4px 0; }\n}\n\n@keyframes vibe-block-design-wizard-reveal {\n  from { opacity: 0.45; translate: 0 4px; }\n  to { opacity: 1; translate: 0 0; }\n}\n\n@keyframes vibe-block-design-wizard-parallax {\n  from { translate: -3px -1px; }\n  to { translate: 4px 2px; }\n}\n\n@keyframes vibe-block-design-wizard-tilt {\n  from { rotate: -3deg; translate: 0 1px; }\n  to { rotate: 3deg; translate: 0 -2px; }\n}\n\n@keyframes vibe-block-design-wizard-particle {\n  from { scale: 0.75; translate: -2px 2px; }\n  to { scale: 1.08; translate: 3px -3px; }\n}\n\n@keyframes vibe-block-design-wizard-morph {\n  from { border-radius: 4px 12px 4px 12px; scale: 0.96; }\n  to { border-radius: 13px 4px 13px 4px; scale: 1.02; }\n}\n\n/* Semantic preview layer: layout controls composition, motif controls content, motion controls behaviour. */\n.vibe-block-design-wizard-preview {\n  --vibe-block-design-wizard-motion-distance: 4px;\n  --vibe-block-design-wizard-motion-duration: 3s;\n  display: block;\n  padding: 0;\n  background: linear-gradient(145deg, #e8efff 0%, #f6edff 100%);\n}\n\n.vibe-block-design-wizard-preview--intensity-low {\n  --vibe-block-design-wizard-motion-distance: 2px;\n  --vibe-block-design-wizard-motion-duration: 4.6s;\n}\n\n.vibe-block-design-wizard-preview--intensity-high {\n  --vibe-block-design-wizard-motion-distance: 8px;\n  --vibe-block-design-wizard-motion-duration: 1.8s;\n}\n\n.vibe-block-design-wizard-preview__glow {\n  position: absolute;\n  inset: -22px auto auto -18px;\n  width: 76px;\n  height: 76px;\n  border-radius: 50%;\n  background: rgba(90, 129, 255, 0.2);\n  filter: blur(12px);\n}\n\n.vibe-block-design-wizard-preview__stage {\n  position: absolute;\n  inset: 8px;\n  z-index: 1;\n  display: grid;\n  gap: 5px;\n  transform-origin: center;\n}\n\n.vibe-block-design-wizard-preview .vibe-block-design-wizard-preview__item {\n  position: static;\n  display: block;\n  width: auto;\n  height: auto;\n  min-width: 0;\n  min-height: 0;\n  border-radius: 5px;\n  background: rgba(255, 255, 255, 0.94);\n  box-shadow: 0 2px 7px rgba(50, 75, 130, 0.14);\n  transform: none;\n}\n\n.vibe-block-design-wizard-preview--carousel .vibe-block-design-wizard-preview__stage {\n  inset-inline: -14px;\n  grid-template-columns: 19px 1fr 1fr 19px;\n  align-items: center;\n}\n\n.vibe-block-design-wizard-preview--carousel .vibe-block-design-wizard-preview__item {\n  height: 47px;\n  border-radius: 8px;\n}\n\n.vibe-block-design-wizard-preview--carousel .vibe-block-design-wizard-preview__item:nth-child(n + 5) {\n  display: none;\n}\n\n.vibe-block-design-wizard-preview--grid .vibe-block-design-wizard-preview__stage,\n.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__stage {\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n}\n\n.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__item--1 {\n  grid-row: span 2;\n}\n\n.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__item--2 {\n  grid-column: span 2;\n}\n\n.vibe-block-design-wizard-preview--mosaic .vibe-block-design-wizard-preview__item--6 {\n  display: none;\n}\n\n.vibe-block-design-wizard-preview--split .vibe-block-design-wizard-preview__stage {\n  grid-template-columns: 1.15fr 0.85fr;\n  grid-template-rows: 1fr 9px 9px;\n}\n\n.vibe-block-design-wizard-preview--split .vibe-block-design-wizard-preview__item--1 {\n  grid-row: 1 / 4;\n  border-radius: 8px;\n}\n\n.vibe-block-design-wizard-preview--split .vibe-block-design-wizard-preview__item:nth-child(n + 5) {\n  display: none;\n}\n\n.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__stage {\n  display: block;\n}\n\n.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item {\n  position: absolute;\n  top: 3px;\n  width: 55px;\n  height: 43px;\n  border-radius: 8px;\n}\n\n.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--1 { left: 7px; rotate: -8deg; }\n.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--2 { left: 24px; z-index: 2; }\n.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--3 { left: 41px; rotate: 8deg; }\n.vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item:nth-child(n + 4) { display: none; }\n\n.vibe-block-design-wizard-preview--timeline .vibe-block-design-wizard-preview__stage {\n  grid-template-columns: 11px 1fr;\n  grid-template-rows: repeat(3, 1fr);\n  gap: 5px 7px;\n}\n\n.vibe-block-design-wizard-preview--timeline .vibe-block-design-wizard-preview__stage::before {\n  position: absolute;\n  top: 4px;\n  bottom: 4px;\n  left: 4px;\n  width: 2px;\n  border-radius: 2px;\n  background: #89a5ef;\n  content: '';\n}\n\n.vibe-block-design-wizard-preview--timeline .vibe-block-design-wizard-preview__item:nth-child(odd) {\n  z-index: 1;\n  border-radius: 50%;\n  background: #527cf0;\n}\n\n.vibe-block-design-wizard-preview--marquee .vibe-block-design-wizard-preview__stage {\n  inset-inline: -34px;\n  display: flex;\n  align-items: center;\n  width: 238px;\n}\n\n.vibe-block-design-wizard-preview--marquee .vibe-block-design-wizard-preview__item {\n  width: 34px;\n  height: 39px;\n  flex: 0 0 auto;\n  border-radius: 8px;\n}\n\n.vibe-block-design-wizard-preview--spotlight .vibe-block-design-wizard-preview__stage {\n  grid-template-columns: 17px 1fr 17px;\n  grid-template-rows: 1fr 9px;\n}\n\n.vibe-block-design-wizard-preview--spotlight .vibe-block-design-wizard-preview__item--2 {\n  grid-row: span 2;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(62, 92, 166, 0.25);\n}\n\n.vibe-block-design-wizard-preview--spotlight .vibe-block-design-wizard-preview__item:nth-child(n + 6) {\n  display: none;\n}\n\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__stage,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__stage {\n  display: block;\n}\n\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item {\n  position: absolute;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: #718fe8;\n  transform-origin: 51px 26px;\n}\n\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--1,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--1 {\n  top: 9px;\n  left: 34px;\n  width: 35px;\n  height: 35px;\n  background: linear-gradient(135deg, #7397ff, #c28cff);\n}\n\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--2,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--2 { top: 1px; left: 18px; }\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--3,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--3 { top: 7px; right: 15px; }\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--4,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--4 { bottom: 1px; left: 18px; }\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--5,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--5 { right: 11px; bottom: 4px; }\n.vibe-block-design-wizard-preview--canvas .vibe-block-design-wizard-preview__item--6,\n.vibe-block-design-wizard-preview--custom .vibe-block-design-wizard-preview__item--6 { top: 0; left: 49px; }\n\n/* Motifs make otherwise similar layouts communicate different content. */\n.vibe-block-design-wizard-preview--motif-gallery .vibe-block-design-wizard-preview__item,\n.vibe-block-design-wizard-preview--motif-product .vibe-block-design-wizard-preview__item--1 {\n  background: linear-gradient(145deg, #7aa0ff, #d49be6 72%, #f6d4b7);\n}\n\n.vibe-block-design-wizard-preview--motif-gallery .vibe-block-design-wizard-preview__item::after,\n.vibe-block-design-wizard-preview--motif-product .vibe-block-design-wizard-preview__item--1::after {\n  display: block;\n  width: 55%;\n  height: 4px;\n  margin: calc(100% - 8px) 4px 0;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.75);\n  content: '';\n}\n\n.vibe-block-design-wizard-preview--motif-cards .vibe-block-design-wizard-preview__item::before {\n  display: block;\n  height: 34%;\n  border-radius: inherit;\n  background: linear-gradient(135deg, #84a6ff, #b694ef);\n  content: '';\n}\n\n.vibe-block-design-wizard-preview--motif-character .vibe-block-design-wizard-preview__item--1 {\n  border: 5px solid rgba(255, 255, 255, 0.9);\n  border-radius: 50%;\n  background: linear-gradient(145deg, #789cff, #bd91e8);\n}\n\n.vibe-block-design-wizard-preview--motif-character .vibe-block-design-wizard-preview__item--2,\n.vibe-block-design-wizard-preview--motif-character .vibe-block-design-wizard-preview__item--3,\n.vibe-block-design-wizard-preview--motif-content .vibe-block-design-wizard-preview__item:nth-child(n + 2) {\n  align-self: center;\n  height: 6px;\n  box-shadow: none;\n}\n\n.vibe-block-design-wizard-preview--motif-product .vibe-block-design-wizard-preview__item--3,\n.vibe-block-design-wizard-preview--motif-cta .vibe-block-design-wizard-preview__item--3,\n.vibe-block-design-wizard-preview--motif-cta .vibe-block-design-wizard-preview__item--6 {\n  align-self: center;\n  height: 9px;\n  border-radius: 999px;\n  background: #4f7af0;\n}\n\n.vibe-block-design-wizard-preview--motif-timeline .vibe-block-design-wizard-preview__item:nth-child(odd) {\n  border-radius: 50%;\n  background: #527cf0;\n}\n\n.vibe-block-design-wizard-preview--motif-abstract .vibe-block-design-wizard-preview__item {\n  background: linear-gradient(135deg, #6e94fb, #bb8dea);\n}\n\n.vibe-block-design-wizard-preview--accent-image .vibe-block-design-wizard-preview__glow {\n  background: rgba(183, 108, 234, 0.25);\n}\n\n.vibe-block-design-wizard-preview--accent-cta .vibe-block-design-wizard-preview__motion-cue,\n.vibe-block-design-wizard-preview--accent-motion .vibe-block-design-wizard-preview__motion-cue {\n  border-color: rgba(62, 102, 216, 0.58);\n  background-color: #4d79ee;\n}\n\n/* Motion families are intentionally different rather than variations of one float. */\n.vibe-block-design-wizard-preview--motion-subtle .vibe-block-design-wizard-preview__item {\n  animation: vibe-block-design-wizard-semantic-float var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-slide .vibe-block-design-wizard-preview__stage {\n  animation: vibe-block-design-wizard-semantic-slide var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-reveal .vibe-block-design-wizard-preview__item {\n  animation: vibe-block-design-wizard-semantic-reveal var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite;\n}\n\n.vibe-block-design-wizard-preview--motion-reveal .vibe-block-design-wizard-preview__item:nth-child(2n) { animation-delay: -0.45s; }\n.vibe-block-design-wizard-preview--motion-reveal .vibe-block-design-wizard-preview__item:nth-child(3n) { animation-delay: -0.9s; }\n\n.vibe-block-design-wizard-preview--motion-parallax .vibe-block-design-wizard-preview__item:nth-child(odd) {\n  animation: vibe-block-design-wizard-semantic-parallax-forward var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-parallax .vibe-block-design-wizard-preview__item:nth-child(even) {\n  animation: vibe-block-design-wizard-semantic-parallax-back var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-tilt .vibe-block-design-wizard-preview__stage {\n  animation: vibe-block-design-wizard-semantic-tilt var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-marquee .vibe-block-design-wizard-preview__stage {\n  animation: vibe-block-design-wizard-semantic-marquee var(--vibe-block-design-wizard-motion-duration) linear infinite;\n}\n\n.vibe-block-design-wizard-preview--motion-particles .vibe-block-design-wizard-preview__item:nth-child(n + 2) {\n  animation: vibe-block-design-wizard-semantic-orbit var(--vibe-block-design-wizard-motion-duration) linear infinite;\n}\n\n.vibe-block-design-wizard-preview--motion-particles .vibe-block-design-wizard-preview__item:nth-child(2n) {\n  animation-direction: reverse;\n  animation-duration: calc(var(--vibe-block-design-wizard-motion-duration) * 1.3);\n}\n\n.vibe-block-design-wizard-preview--motion-morph .vibe-block-design-wizard-preview__item {\n  animation: vibe-block-design-wizard-semantic-morph var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-custom .vibe-block-design-wizard-preview__glow {\n  animation: vibe-block-design-wizard-semantic-pulse var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview__motion-cue {\n  display: none !important;\n}\n\n.vibe-block-design-wizard-preview--motion-none .vibe-block-design-wizard-preview__motion-cue {\n  display: none;\n}\n\n.vibe-block-design-wizard-preview--motion-slide .vibe-block-design-wizard-preview__motion-cue,\n.vibe-block-design-wizard-preview--motion-marquee .vibe-block-design-wizard-preview__motion-cue {\n  width: 20px;\n  border-radius: 999px;\n  animation: vibe-block-design-wizard-semantic-cue-slide var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-reveal .vibe-block-design-wizard-preview__motion-cue {\n  animation: vibe-block-design-wizard-semantic-cue-reveal var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite;\n}\n\n.vibe-block-design-wizard-preview--motion-tilt .vibe-block-design-wizard-preview__motion-cue {\n  border-radius: 2px;\n  animation: vibe-block-design-wizard-semantic-cue-tilt var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-preview--motion-particles .vibe-block-design-wizard-preview__motion-cue {\n  border: 0;\n  background: #6488ef;\n  box-shadow: -8px 3px 0 -1px #9a7ee3, 4px -7px 0 -2px #6488ef;\n  animation: vibe-block-design-wizard-semantic-cue-particles var(--vibe-block-design-wizard-motion-duration) ease-in-out infinite alternate;\n}\n\n.vibe-block-design-wizard-card--static .vibe-block-design-wizard-preview__stage,\n.vibe-block-design-wizard-card--static .vibe-block-design-wizard-preview__item,\n.vibe-block-design-wizard-card--static .vibe-block-design-wizard-preview__glow,\n.vibe-block-design-wizard-card--static .vibe-block-design-wizard-preview__motion-cue {\n  animation-play-state: paused;\n}\n\n@keyframes vibe-block-design-wizard-semantic-float {\n  from { translate: 0 1px; }\n  to { translate: 0 calc(var(--vibe-block-design-wizard-motion-distance) * -1); }\n}\n\n@keyframes vibe-block-design-wizard-semantic-slide {\n  from { translate: calc(var(--vibe-block-design-wizard-motion-distance) * -1) 0; }\n  to { translate: var(--vibe-block-design-wizard-motion-distance) 0; }\n}\n\n@keyframes vibe-block-design-wizard-semantic-reveal {\n  0%, 18% { opacity: 0.28; translate: 0 var(--vibe-block-design-wizard-motion-distance); scale: 0.94; }\n  48%, 82% { opacity: 1; translate: 0 0; scale: 1; }\n  100% { opacity: 0.28; translate: 0 calc(var(--vibe-block-design-wizard-motion-distance) * -0.4); scale: 0.97; }\n}\n\n@keyframes vibe-block-design-wizard-semantic-parallax-forward {\n  from { translate: calc(var(--vibe-block-design-wizard-motion-distance) * -1) -1px; }\n  to { translate: var(--vibe-block-design-wizard-motion-distance) 2px; }\n}\n\n@keyframes vibe-block-design-wizard-semantic-parallax-back {\n  from { translate: var(--vibe-block-design-wizard-motion-distance) 1px; }\n  to { translate: calc(var(--vibe-block-design-wizard-motion-distance) * -1) -2px; }\n}\n\n@keyframes vibe-block-design-wizard-semantic-tilt {\n  from { rotate: -2.5deg; scale: 0.98; }\n  to { rotate: 2.5deg; scale: 1.015; }\n}\n\n@keyframes vibe-block-design-wizard-semantic-marquee {\n  from { translate: -14px 0; }\n  to { translate: 24px 0; }\n}\n\n@keyframes vibe-block-design-wizard-semantic-orbit {\n  from { rotate: 0deg; }\n  to { rotate: 360deg; }\n}\n\n@keyframes vibe-block-design-wizard-semantic-morph {\n  from { border-radius: 5px 13px 5px 13px; scale: 0.94; }\n  to { border-radius: 15px 5px 15px 5px; scale: 1.04; }\n}\n\n@keyframes vibe-block-design-wizard-semantic-pulse {\n  from { opacity: 0.45; scale: 0.8; }\n  to { opacity: 1; scale: 1.2; }\n}\n\n@keyframes vibe-block-design-wizard-semantic-cue-slide {\n  from { translate: -4px 0; }\n  to { translate: 2px 0; }\n}\n\n@keyframes vibe-block-design-wizard-semantic-cue-reveal {\n  0%, 25% { opacity: 0.2; scale: 0.6; }\n  55%, 100% { opacity: 1; scale: 1; }\n}\n\n@keyframes vibe-block-design-wizard-semantic-cue-tilt {\n  from { rotate: -15deg; }\n  to { rotate: 15deg; }\n}\n\n@keyframes vibe-block-design-wizard-semantic-cue-particles {\n  from { translate: -2px 1px; }\n  to { translate: 2px -2px; }\n}\n\n.vibe-block-design-wizard-custom {\n  margin-top: 11px;\n  padding: 10px;\n  border: 1px solid #dbe4f7;\n  border-radius: 13px;\n  background: rgba(255, 255, 255, 0.7);\n}\n\n.vibe-block-design-wizard-custom.is-active {\n  border-color: #7599ff;\n}\n\n.vibe-block-design-wizard-custom label {\n  display: block;\n  margin-bottom: 6px;\n  color: #44546e;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.vibe-block-design-wizard-custom textarea {\n  display: block;\n  width: 100%;\n  min-height: 54px;\n  padding: 8px 10px;\n  resize: vertical;\n  border: 1px solid #d9e3f5;\n  border-radius: 9px;\n  outline: none;\n  background: #fff;\n  color: #27344a;\n  font: inherit;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.vibe-block-design-wizard-custom textarea:focus {\n  border-color: #668eff;\n  box-shadow: 0 0 0 3px rgba(75, 124, 255, 0.11);\n}\n\n.vibe-block-design-wizard-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.vibe-block-design-wizard-card__skip,\n.vibe-block-design-wizard-card__submit {\n  min-width: 116px;\n  padding: 9px 16px;\n  border: 0;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  transition: background 150ms ease, color 150ms ease, transform 150ms ease;\n}\n\n.vibe-block-design-wizard-card__skip {\n  background: #edf2fc;\n  color: #52698f;\n}\n\n.vibe-block-design-wizard-card__submit {\n  background: #376df2;\n  color: #fff;\n}\n\n.vibe-block-design-wizard-card__skip:not(:disabled):hover {\n  background: #e0e9fa;\n  color: #3b5788;\n  transform: translateY(-1px);\n}\n\n.vibe-block-design-wizard-card__submit:not(:disabled):hover {\n  background: #245bdc;\n  transform: translateY(-1px);\n}\n\n.vibe-block-design-wizard-card__skip:disabled,\n.vibe-block-design-wizard-card__submit:disabled {\n  background: #bdc8de;\n  color: #fff;\n  cursor: not-allowed;\n}\n\n.vibe-block-design-wizard-card__answered {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  width: 100%;\n  padding: 9px 11px;\n  border-radius: 10px;\n  background: #eaf8ef;\n  color: #2d6745;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.vibe-block-design-wizard-card__answered-label {\n  color: #3e7554;\n  font-size: 10px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.vibe-block-design-wizard-card__answered-effect {\n  color: #527060;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.vibe-block-design-wizard-card__ready {\n  margin-top: 9px;\n  color: #4267b1;\n  font-size: 11px;\n  font-weight: 700;\n  text-align: right;\n}\n\n.vibe-block-design-wizard-progress-summary {\n  margin: 0 0 12px;\n  padding: 9px 10px;\n  border: 1px solid rgba(139, 165, 221, 0.28);\n  border-radius: 12px;\n  background: rgba(236, 243, 255, 0.72);\n}\n\n.vibe-block-design-wizard-progress-summary__label {\n  margin-bottom: 6px;\n  color: #57709f;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.055em;\n  text-transform: uppercase;\n}\n\n.vibe-block-design-wizard-progress-summary ol {\n  display: grid;\n  gap: 5px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.vibe-block-design-wizard-progress-summary li {\n  display: grid;\n  grid-template-columns: 19px minmax(0, 1fr);\n  align-items: start;\n  gap: 7px;\n}\n\n.vibe-block-design-wizard-progress-summary__number {\n  display: grid;\n  width: 18px;\n  height: 18px;\n  place-items: center;\n  border-radius: 50%;\n  background: #dce8ff;\n  color: #3f66b4;\n  font-size: 9px;\n  font-weight: 800;\n}\n\n.vibe-block-design-wizard-progress-summary__answer {\n  overflow: hidden;\n  color: #42526e;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.45;\n  text-overflow: ellipsis;\n}\n\n.vibe-block-design-wizard-step-content {\n  animation: vibe-block-design-wizard-step-enter 220ms ease-out both;\n}\n\n@keyframes vibe-block-design-wizard-step-enter {\n  from { opacity: 0; translate: 0 7px; }\n  to { opacity: 1; translate: 0 0; }\n}\n\n@media (max-width: 560px) {\n  .vibe-block-design-wizard-card { padding: 13px; }\n  .vibe-block-design-wizard-card__header { flex-direction: column; gap: 6px; }\n  .vibe-block-design-wizard-option { grid-template-columns: 92px 1fr; padding-right: 28px; }\n  .vibe-block-design-wizard-preview { width: 92px; }\n  .vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--1 { left: 7px; }\n  .vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--2 { left: 19px; }\n  .vibe-block-design-wizard-preview--stack .vibe-block-design-wizard-preview__item--3 { left: 31px; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .vibe-block-design-wizard-preview__stage,\n  .vibe-block-design-wizard-preview__item,\n  .vibe-block-design-wizard-preview__glow,\n  .vibe-block-design-wizard-preview__motion-cue,\n  .vibe-block-design-wizard-step-content,\n  .vibe-block-art-mascot,\n  .vibe-block-art-mascot--spin-jump,\n  .vibe-block-art-mascot--hop,\n  .vibe-block-art-mascot--spin-burst,\n  .vibe-block-art-mascot--tilt,\n  .vibe-block-art-mascot--float,\n  .vibe-block-art-mascot--aura,\n  .vibe-block-art-mascot--cursor-hover,\n  .vibe-block-art-mascot--tap-ripple,\n  .vibe-block-art-mascot--speed-dash,\n  .vibe-block-art-mascot--float-smooth,\n  .vibe-block-art-mascot--scroll-reveal,\n  .vibe-block-art-sparkle-burst,\n  .vibe-block-art-aura-rings,\n  .vibe-block-art-cursor-pointer,\n  .vibe-block-art-tap-ripple-group,\n  .vibe-block-art-speed-streaks,\n  .vibe-block-art-grid-item,\n  .vibe-block-art-carousel-track,\n  .vibe-block-art-vortex,\n  .vibe-block-art-firefly {\n    animation: none !important;\n  }\n\n  .vibe-block-design-wizard-option,\n  .vibe-block-design-wizard-card__skip,\n  .vibe-block-design-wizard-card__submit { transition: none; }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
